
// import React, { useEffect, useState } from "react";
// import {
//   Search,
//   Download,
//   Printer,
//   FileSpreadsheet,
//   FileText,
// } from "lucide-react";
// import { FaCheckCircle } from "react-icons/fa";
// import jsPDF from "jspdf";
// import autoTable from "jspdf-autotable";
// import axios from "axios";
// import Apiurl from "./../../environment/Apiurl"; // Ensure this is correctly defined

// const ReportPharmacy = () => {
//   const [activeTab, setActiveTab] = useState("medicineMaster");
//   const [searchTerm, setSearchTerm] = useState("");
//   const [currentPage, setCurrentPage] = useState(1);
//   const [itemsPerPage, setItemsPerPage] = useState(5);
//   const [fromDate, setFromDate] = useState("");
//   const [toDate, setToDate] = useState("");
//   const [paymentMode, setPaymentMode] = useState("");
//   const [category, setCategory] = useState("");
//   const [isLoading, setIsLoading] = useState(false);

//   const [medicineMasterData, setMedicineMasterData] = useState([]);
//   const [purchaseOrderData, setPurchaseOrderData] = useState([]);
//   const [purchaseListData, setPurchaseListData] = useState([]);
//   const [salePharmacyData, setSalesPharmacyData] = useState([]);
//   const [salelist, setSaleslist] = useState([]);
//   const [stockPharmacyData, setStockPharmacyData] = useState([]);

//   // Fetch data functions
//   const fetchMedicineMasterData = async () => {
//     setIsLoading(true);
//     try {
//       const response = await axios.get(`${Apiurl}/medicine_master`);
//       setMedicineMasterData(response.data || []);
//     } catch (error) {
//       console.error("Error fetching Medicine Master data:", error.message);
//       setMedicineMasterData([]);
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   const fetchPurchaseOrderData = async () => {
//     setIsLoading(true);
//     try {
//       const response = await axios.get(`${Apiurl}/purchase_order`);
//       setPurchaseOrderData(response.data || []);
//     } catch (error) {
//       console.error("Error fetching Purchase Order data:", error.message);
//       setPurchaseOrderData([]);
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   const fetchPurchaseListData = async () => {
//     setIsLoading(true);
//     try {
//       const response = await axios.get(`${Apiurl}/purchase_pharmacy_list`);
//       setPurchaseListData(response.data || []);
//     } catch (error) {
//       console.error("Error fetching Purchase Pharmacy data:", error.message);
//       setPurchaseListData([]);
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   const fetchSalePharmacyData = async () => {
//     setIsLoading(true);
//     try {
//       const response = await axios.get(`${Apiurl}/sale`);
//       setSalesPharmacyData(response.data || []);


//   const saleList = Array.isArray(response.data) ? response.data : [];

//   // Calculate total sum
//   const totalSum = saleList.reduce(
//     (sum, item) => sum + parseFloat(item.paid || 0),
//     0 
//   );

//   console.log("Sum of total:", totalSum);

//     } catch (error) {
//       console.error("Error fetching Sale Pharmacy data:", error.message);
//       setSalesPharmacyData([]);
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   const fetchSalelist = async () => {
//     setIsLoading(true);
//     try {
//       const response = await axios.get(`${Apiurl}/sale_list_data`);
//       setSaleslist(response.data || []);

//     } catch (error) {
//       console.error("Error fetching Sale List data:", error.message);
//       setSaleslist([]);
//     } finally {
//       setIsLoading(false);
//     }
//   };


//   const fetchStockPharmacyData = async () => {
//     setIsLoading(true);
//     try {
//       const response = await axios.get(`${Apiurl}/stock_pharmacy`);
//       setStockPharmacyData(response.data || []);
//     } catch (error) {
//       console.error("Error fetching Stock Pharmacy data:", error.message);
//       setStockPharmacyData([]);
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   useEffect(() => {
//     window.scrollTo({ top: 0, behavior: "smooth" });
//   }, []);

//   useEffect(() => {
//     fetchMedicineMasterData();
//     fetchPurchaseOrderData();
//     fetchPurchaseListData();
//     fetchSalePharmacyData();
//     fetchSalelist();
//     fetchStockPharmacyData();
//   }, []);

//   // Tab configurations
//   const tabConfig = {
//     medicineMaster: {
//       title: "Medicine Master",
//       headers: ["S.No", "Medicine", "Category", "Medicine Type", "Manufacturer", "HSN Code"],
//       fields: ["medicine_name", "category", "medicine_type", "manufacturer", "hsn_code"],
//       data: medicineMasterData,
//     },
//     purchaseOrder: {
//       title: "Purchase Order",
//       headers: ["S.No", "Date", "Pur Order No", "Supplier Name", "Order Status"],
//       fields: ["date", "purchase_order_no", "supplier_details[0].supplier_name", "order_status"],
//       data: purchaseOrderData,
//     },
//     purchasePharmacy: {
//       title: "Purchase Product List",
//       headers: [
//         "S.No",
//         "Purchase Date",
//         "Invoice No",
//         "Supplier ID",
//         "Supplier ",
//         "Medicine",
//         "Category",
//         "HSN",
//         "Batch No",
//         "Unit Pack",
//         "Pur Price",
//         "Qty",
//         "Taxable",
//         "Discount",
//         "Tax(%)",
//         "CGST",
//         "SGST",
//         "Tax Value",

//         "Amount (₹)",
//       ],
//       fields: [
//         "purchase_date",
//         "invoice_number",
//         "supplier_id",
//         "supplier_name",
//         "medicine_name",
//         "category",
//         "hsn_code",
//         "batch_no",
//         "unit_pack",
//         "purchase_price",
//         "quantity",
//         "",
//         "discount_per_tablet",
//         "gst_percentage",
//         "",
//         "",


//         "tax",

//         "total",
//       ],
//       data: purchaseListData,
//     },
//     salePharmacy: {
//       title: "Sale Pharmacy",
//       headers: [
//         "S.No",
//         "Sale Date",
//         "Invoice No",
//         "Patient ID",
//         "Patient Name",
//         "Category",
//         "Pur Price",
//         "MRP",
//         "Qty",
//         "Net Total",
//         "Paid",
//         "PayType",
//         "Profit",
//       ],
//       fields: [
//         "sale_date",
//         "invoice_number",
//         "patient_id",
//         "patient_details[0].first_name",
//         "patient_details[0].patient_type",
//         "sales_list[0].purchase_price_per_unit",
//         "sales_list[0].mrp",
//         "sales_list[0].quantity",
//         "net_total",
//         "paid",
//         "sales_pharmacy_payment[0].pay_type",
//         "profit",
//       ],
//       data: salePharmacyData,
//     },
//     salelist: {
//       title: "Sales Product List",
//       headers: [
//         "S.No",
//         "Sale Date",
//         "Invoice No",
//         "Patient ID",
//         "Patient Name",
//         "Medicine Name",
//         "HSN Code",
//         "Category",
//         "MRP",
//         "Qty",
//         "Tax(%)",
//         "CGST",
//         "SGST",
//         "Tax Value",
//         "Total",
//       ],
//       fields: [
//         "sale_date",
//         "invoice_number",
//         "patient_id",
//         "patient_name",
//         "medicine_name",
//         "hsn_code",
//         "category",
//         "mrp",
//         "qty",
//         "tax",
//         "cgst",
//         "sgst",
//         "tax_row_value",
//         "total",
//       ],
//       data: salelist,
//     },
//     stockManagement: {
//       title: "Stock Management",
//       headers: [
//         "S.No",
//         "Medicine",
//         "Category",
//         "Batch No",
//         "Exp Date",
//         "InQty",
//         "OutQty",
//         "Balance",
//         "Pur Price",
//         "MRP",
//         "Profit",
//       ],
//       fields: [
//         "medicine_details.medicine_name",
//         "medicine_details.category",
//         "batch_no",
//         "expiry_date",
//         "inward_quantity",
//         "outward_quantity",
//         "balance_quantity",
//         "purchase_price",
//         "mrp",
//         "profit",
//       ],
//       data: stockPharmacyData,
//     },
//   };

//   // Calculate per tablet price, per tablet MRP, and profit for stock items
//   const calculateStockValues = (item) => {
//     const purchasePrice = parseFloat(item.purchase_price) || 0;
//     const mrp = parseFloat(item.mrp) || 0;
//     let tabletsPerPack = 1;

//     if (typeof item.unit_pack === "string" && item.unit_pack.includes("*")) {
//       const parts = item.unit_pack.split("*").map((part) => parseInt(part.trim()));
//       if (parts.length === 2 && !isNaN(parts[1])) {
//         tabletsPerPack = parts[1];
//       }
//     }

//     const perTabletPrice = tabletsPerPack > 0 ? purchasePrice / tabletsPerPack : 0;
//     const perTabletMrp = tabletsPerPack > 0 ? mrp / tabletsPerPack : 0;
//     const profit = parseFloat(item.profit) || 0;

//     return {
//       perTabletPrice: perTabletPrice.toFixed(2),
//       perTabletMrp: perTabletMrp.toFixed(2),
//       profit: profit.toFixed(2),
//     };
//   };

//   // Get nested field value
//   const getNestedValue = (obj, path) => {
//     if (!obj) return "N/A";

//     // Handle profit for salePharmacy
//     if (path === "profit" && activeTab === "salePharmacy") {
//       if (!obj.sales_list || !Array.isArray(obj.sales_list)) {
//         console.warn(`Missing or invalid sales_list for invoice ${obj.invoice_number || "unknown"}`);
//         return "0.00";
//       }
//       return obj.sales_list
//         .reduce((sum, sl) => sum + (parseFloat(sl.profit) || 0), 0)
//         .toFixed(2);
//     }

//     // Handle sales_pharmacy_payment
//     if (path === "sales_pharmacy_payment[0].pay_type") {
//       const payments = Array.isArray(obj.sales_pharmacy_payment) ? obj.sales_pharmacy_payment : [];
//       if (paymentMode) {
//         const filteredPayments = payments.filter((p) => p.pay_type === paymentMode);
//         return filteredPayments.length > 0 ? paymentMode : "N/A";
//       }
//       return payments.map((p) => p.pay_type).join(", ") || "N/A";
//     }

//     // Handle stockManagement profit
//     if (activeTab === "stockManagement" && path === "profit") {
//       return calculateStockValues(obj).profit;
//     }

//     // Handle numeric fields for salelist and purchasePharmacy
//     if (
//       ["salelist", "purchasePharmacy"].includes(activeTab) &&
//       ["mrp", "qty", "tax", "cgst", "sgst", "tax_row_value", "total"].includes(path)
//     ) {
//       const value = parseFloat(obj[path]);
//       return isNaN(value) || obj[path] === null || obj[path] === undefined
//         ? "0.00"
//         : value.toFixed(2);
//     }

//     // Handle quantity for purchasePharmacy
//     if (activeTab === "purchasePharmacy" && path === "quantity") {
//       const value = parseInt(obj[path]);
//       return isNaN(value) || obj[path] === null || obj[path] === undefined
//         ? "0"
//         : value.toString();
//     }

//     // General nested value extraction
//     const parts = path.match(/(\w+|\[\d+\])/g) || [path];
//     let current = obj;

//     for (let part of parts) {
//       if (part.startsWith("[") && part.endsWith("]")) {
//         const index = parseInt(part.slice(1, -1));
//         current = current ? current[index] : undefined;
//       } else {
//         current = current ? current[part] : undefined;
//       }
//       if (!current) break;
//     }

//     if (
//       ["sub_total", "net_total", "discount_value", "paid", "purchase_price", "mrp"].includes(
//         path.split(".").pop()
//       )
//     ) {
//       const value = parseFloat(current);
//       return isNaN(value) || current === null || current === undefined
//         ? "0.00"
//         : value.toFixed(2);
//     }

//     return current || "N/A";
//   };

//   // Get filtered data based on tab and filters
//   const getCurrentData = () => {
//     const config = tabConfig[activeTab];
//     if (!config) return [];

//     let filteredData = config.data || [];

//     // Apply category filter for Medicine Master
//     if (activeTab === "medicineMaster" && category) {
//       filteredData = filteredData.filter((item) => item.category === category);
//     }

//     // Apply category filter for Stock Management
//     if (activeTab === "stockManagement" && category) {
//       filteredData = filteredData.filter((item) => item.medicine_details?.category === category);
//     }

//     // Apply category and date filters for Sale List
//     if (activeTab === "salelist") {
//       filteredData = filteredData.filter((item) => {
//         let dateMatch = true;
//         let categoryMatch = true;

//         if (fromDate || toDate) {
//           const saleDate = new Date(item.sale_date);
//           if (isNaN(saleDate.getTime())) {
//             console.warn(`Invalid sale_date for invoice ${item.invoice_number || "unknown"}`);
//             return false;
//           }

//           if (fromDate) {
//             const from = new Date(fromDate);
//             from.setHours(0, 0, 0, 0);
//             saleDate.setHours(0, 0, 0, 0);
//             if (saleDate < from) {
//               dateMatch = false;
//             }
//           }

//           if (toDate && dateMatch) {
//             const to = new Date(toDate);
//             to.setHours(23, 59, 59, 999);
//             const saleDateEnd = new Date(item.sale_date);
//             saleDateEnd.setHours(23, 59, 59, 999);
//             if (saleDateEnd > to) {
//               dateMatch = false;
//             }
//           }
//         }

//         if (category) {
//           categoryMatch = item.category === category;
//         }

//         return dateMatch && categoryMatch;
//       });
//     }

//     // Apply date, payment mode, and category filters for Sale Pharmacy
//     if (activeTab === "salePharmacy") {
//       filteredData = filteredData.filter((item) => {
//         let dateMatch = true;

//         if (fromDate || toDate) {
//           const saleDate = new Date(item.sale_date);
//           if (isNaN(saleDate.getTime())) {
//             console.warn(`Invalid sale_date for invoice ${item.invoice_number || "unknown"}`);
//             return false;
//           }

//           if (fromDate) {
//             const from = new Date(fromDate);
//             from.setHours(0, 0, 0, 0);
//             saleDate.setHours(0, 0, 0, 0);
//             if (saleDate < from) {
//               dateMatch = false;
//             }
//           }

//           if (toDate && dateMatch) {
//             const to = new Date(toDate);
//             to.setHours(23, 59, 59, 999);
//             const saleDateEnd = new Date(item.sale_date);
//             saleDateEnd.setHours(23, 59, 59, 999);
//             if (saleDateEnd > to) {
//               dateMatch = false;
//             }
//           }
//         }

//         let paymentMatch = true;
//         if (paymentMode) {
//           const payments = Array.isArray(item.sales_pharmacy_payment) ? item.sales_pharmacy_payment : [];
//           paymentMatch = payments.some((p) => p.pay_type === paymentMode);
//         }

//         let categoryMatch = true;
//         if (category) {
//           const patientType = item.patient_details && item.patient_details[0] ? item.patient_details[0].patient_type : null;
//           categoryMatch = patientType === category;
//         }

//         return dateMatch && paymentMatch && categoryMatch;
//       });
//     }

//     // Apply date filtering for Purchase Order
//     if (activeTab === "purchaseOrder" && (fromDate || toDate)) {
//       filteredData = filteredData.filter((item) => {
//         let dateMatch = true;

//         if (fromDate || toDate) {
//           const itemDate = new Date(item.date);
//           if (isNaN(itemDate.getTime())) {
//             console.warn(`Invalid date for purchase order ${item.purchase_order_no || "unknown"}`);
//             return false;
//           }

//           if (fromDate) {
//             const from = new Date(fromDate);
//             from.setHours(0, 0, 0, 0);
//             itemDate.setHours(0, 0, 0, 0);
//             if (itemDate < from) {
//               dateMatch = false;
//             }
//           }

//           if (toDate && dateMatch) {
//             const to = new Date(toDate);
//             to.setHours(23, 59, 59, 999);
//             const itemDateEnd = new Date(item.date);
//             itemDateEnd.setHours(23, 59, 59, 999);
//             if (itemDateEnd > to) {
//               dateMatch = false;
//             }
//           }
//         }

//         return dateMatch;
//       });
//     }

//     // Apply date filtering for Purchase Pharmacy
//     if (activeTab === "purchasePharmacy" && (fromDate || toDate)) {
//       filteredData = filteredData.filter((item) => {
//         let dateMatch = true;

//         if (fromDate || toDate) {
//           const itemDate = new Date(item.purchase_date);
//           if (isNaN(itemDate.getTime())) {
//             console.warn(`Invalid purchase_date for invoice ${item.invoice_number || "unknown"}`);
//             return false;
//           }

//           if (fromDate) {
//             const from = new Date(fromDate);
//             from.setHours(0, 0, 0, 0);
//             itemDate.setHours(0, 0, 0, 0);
//             if (itemDate < from) {
//               dateMatch = false;
//             }
//           }

//           if (toDate && dateMatch) {
//             const to = new Date(toDate);
//             to.setHours(23, 59, 59, 999);
//             const itemDateEnd = new Date(item.purchase_date);
//             itemDateEnd.setHours(23, 59, 59, 999);
//             if (itemDateEnd > to) {
//               dateMatch = false;
//             }
//           }
//         }

//         return dateMatch;
//       });
//     }

//     return filteredData.map((item, index) => {
//       const row = { sNo: index + 1 };
//       config.fields.forEach((field) => {
//         if (field === "paid" && activeTab === "salePharmacy" && paymentMode) {
//           const payments = Array.isArray(item.sales_pharmacy_payment) ? item.sales_pharmacy_payment : [];
//           const paymentAmount = payments
//             .filter((p) => p.pay_type === paymentMode)
//             .reduce((sum, p) => sum + (parseFloat(p.paid_amount) || 0), 0);
//           row[field] = paymentAmount > 0 ? paymentAmount.toFixed(2) : "0.00";
//         } else {
//           row[field] = getNestedValue(item, field);
//         }
//       });
//       return row;
//     });
//   };

//   // Handle tab change
//   const handleTabChange = (key) => {
//     setActiveTab(key);
//     setCurrentPage(1);
//     setSearchTerm("");
//     setFromDate("");
//     setToDate("");
//     setPaymentMode("");
//     setCategory("");
//   };

//   // Filter data based on search term
//   const getFilteredData = () => {
//     const currentData = getCurrentData();
//     if (!searchTerm) return currentData;

//     return currentData.filter((item) =>
//       Object.values(item).some((value) =>
//         value?.toString().toLowerCase().includes(searchTerm.toLowerCase())
//       )
//     );
//   };

//   // Get paginated data
//   const getPaginatedData = () => {
//     const filteredData = getFilteredData();
//     const startIndex = (currentPage - 1) * itemsPerPage;
//     return filteredData.slice(startIndex, startIndex + itemsPerPage);
//   };

//   // Calculate total pages
//   const getTotalPages = () => {
//     return Math.ceil(getFilteredData().length / itemsPerPage);
//   };

//   // Calculate totals for Sale Pharmacy
//   const getSalePharmacyTotals = () => {
//     if (activeTab !== "salePharmacy") return { netTotal: 0, paid: 0, profit: 0 };

//     const filteredData = getFilteredData();
//     return filteredData.reduce(
//       (acc, item) => {
//         const netTotal = parseFloat(item.net_total) || 0;
//         let paidAmount = 0;
//         const profit = parseFloat(item.profit) || 0;

//         if (paymentMode) {
//           const originalItem = salePharmacyData.find(
//             (orig) => orig.sale_date === item.sale_date && orig.invoice_number === item.invoice_number
//           );
//           if (originalItem) {
//             const payments = Array.isArray(originalItem.sales_pharmacy_payment)
//               ? originalItem.sales_pharmacy_payment
//               : [];
//             paidAmount = payments
//               .filter((p) => p.pay_type === paymentMode)
//               .reduce((sum, p) => sum + (parseFloat(p.paid_amount) || 0), 0);
//           }
//         } else {
//           paidAmount = parseFloat(item.paid) || 0;
//         }

//         return {
//           netTotal: acc.netTotal + netTotal,
//           paid: acc.paid + paidAmount,
//           profit: acc.profit + profit,
//         };
//       },
//       { netTotal: 0, paid: 0, profit: 0 }
//     );
//   };

//   // Calculate totals for Sale List
//   const getSaleListTotals = () => {
//     if (activeTab !== "salelist") return {
//       mrp: 0,
//       qty: 0,
//       tax: 0,
//       cgst: 0,
//       sgst: 0,
//       tax_row_value: 0,
//       total: 0,
//     };

//     const filteredData = getFilteredData();
//     return filteredData.reduce(
//       (acc, item) => ({
//         mrp: acc.mrp + (parseFloat(item.mrp) || 0),
//         qty: acc.qty + (parseFloat(item.qty) || 0),
//         tax: acc.tax + (parseFloat(item.tax) || 0),
//         cgst: acc.cgst + (parseFloat(item.cgst) || 0),
//         sgst: acc.sgst + (parseFloat(item.sgst) || 0),
//         tax_row_value: acc.tax_row_value + (parseFloat(item.tax_row_value) || 0),
//         total: acc.total + (parseFloat(item.total) || 0),
//       }),
//       {
//         mrp: 0,
//         qty: 0,
//         tax: 0,
//         cgst: 0,
//         sgst: 0,
//         tax_row_value: 0,
//         total: 0,
//       }
//     );
//   };

//   // Calculate totals for Stock Management
//   const getStockManagementTotals = () => {
//     if (activeTab !== "stockManagement") return { totalPurchasePrice: 0, totalMrp: 0, totalProfit: 0 };

//     const filteredData = getFilteredData();
//     return filteredData.reduce(
//       (acc, item) => {
//         const purchasePrice = parseFloat(item.purchase_price) || 0;
//         const mrp = parseFloat(item.mrp) || 0;
//         const profit = parseFloat(item.profit) || 0;

//         return {
//           totalPurchasePrice: acc.totalPurchasePrice + purchasePrice,
//           totalMrp: acc.totalMrp + mrp,
//           totalProfit: acc.totalProfit + profit,
//         };
//       },
//       { totalPurchasePrice: 0, totalMrp: 0, totalProfit: 0 }
//     );
//   };

//   // Calculate totals for Purchase Pharmacy (corrected to include tax)
//   const getPurchasePharmacyTotals = () => {
//     if (activeTab !== "purchasePharmacy") return { quantity: 0, tax: 0, mrp: 0, total: 0 };

//     const filteredData = getFilteredData();
//     return filteredData.reduce(
//       (acc, item) => ({
//         quantity: acc.quantity + (parseInt(item.quantity) || 0),
//         tax: acc.tax + (parseFloat(item.tax) || 0),
//         mrp: acc.mrp + (parseFloat(item.mrp) || 0),
//         total: acc.total + (parseFloat(item.total) || 0),
//       }),
//       { quantity: 0, tax: 0, mrp: 0, total: 0 }
//     );
//   };

//   // Export functions
//   const downloadCSV = () => {
//     const currentData = getFilteredData();
//     const config = tabConfig[activeTab];
//     const headers = config.headers;
//     const fields = ["sNo", ...config.fields];

//     let csvContent = headers.join(",") + "\n";
//     currentData.forEach((item) => {
//       const row = fields.map((field) => `"${item[field] || ""}"`).join(",");
//       csvContent += row + "\n";
//     });

//     if (activeTab === "salePharmacy") {
//       const totals = getSalePharmacyTotals();
//       const totalsRow = [
//         "",
//         "",
//         "",
//         "",
//         "",
//         "",
//         "",
//         "",
//         "",
//         (totals.netTotal || 0).toFixed(2),
//         (totals.paid || 0).toFixed(2),
//         "",
//         (totals.profit || 0).toFixed(2),
//       ];
//       csvContent += totalsRow.join(",") + "\n";
//     }

//     if (activeTab === "salelist") {
//       const totals = getSaleListTotals();
//       const totalsRow = [
//         "",
//         "",
//         "",
//         "",
//         "",
//         "",
//         "",
//         "",
//         (totals.mrp || 0).toFixed(2),
//         (totals.qty || 0).toFixed(2),
//         (totals.tax || 0).toFixed(2),
//         (totals.cgst || 0).toFixed(2),
//         (totals.sgst || 0).toFixed(2),
//         (totals.tax_row_value || 0).toFixed(2),
//         (totals.total || 0).toFixed(2),
//       ];
//       csvContent += totalsRow.join(",") + "\n";
//     }

//     if (activeTab === "stockManagement") {
//       const totals = getStockManagementTotals();
//       const totalsRow = [
//         "",
//         "",
//         "",
//         "",
//         "",
//         "",
//         "",
//         "",
//         (totals.totalPurchasePrice || 0).toFixed(2),
//         (totals.totalMrp || 0).toFixed(2),
//         (totals.totalProfit || 0).toFixed(2),
//       ];
//       csvContent += totalsRow.join(",") + "\n";
//     }

//     if (activeTab === "purchasePharmacy") {
//       const totals = getPurchasePharmacyTotals();
//       const totalsRow = [
//         "",
//         "",
//         "",
//         "",
//         "",
//         "",
//         "",
//         "",
//         "",
//         "",
//         totals.quantity || 0,
//         (totals.tax || 0).toFixed(2),
//         (totals.mrp || 0).toFixed(2),
//         (totals.total || 0).toFixed(2),
//       ];
//       csvContent += totalsRow.join(",") + "\n";
//     }

//     const blob = new Blob([csvContent], { type: "text/csv" });
//     const url = window.URL.createObjectURL(blob);
//     const a = document.createElement("a");
//     a.href = url;
//     a.download = `${activeTab}_report.csv`;
//     a.click();
//     window.URL.revokeObjectURL(url);
//   };

//   const downloadExcel = () => {
//     const currentData = getFilteredData();
//     const config = tabConfig[activeTab];
//     const headers = config.headers;
//     const fields = ["sNo", ...config.fields];

//     let excelContent = '<table border="1">';
//     excelContent += "<tr>" + headers.map((h) => `<th>${h}</th>`).join("") + "</tr>";

//     currentData.forEach((item) => {
//       excelContent += "<tr>" + fields.map((field) => `<td>${item[field] || ""}</td>`).join("") + "</tr>";
//     });

//     if (activeTab === "salePharmacy") {
//       const totals = getSalePharmacyTotals();
//       excelContent +=
//         "<tr>" +
//         [
//           "",
//           "",
//           "",
//           "",
//           "",
//           "",
//           "",
//           "",
//           "",
//           (totals.netTotal || 0).toFixed(2),
//           (totals.paid || 0).toFixed(2),
//           "",
//           (totals.profit || 0).toFixed(2),
//         ]
//           .map((val) => `<td>${val}</td>`)
//           .join("") +
//         "</tr>";
//     }

//     if (activeTab === "salelist") {
//       const totals = getSaleListTotals();
//       excelContent +=
//         "<tr>" +
//         [
//           "",
//           "",
//           "",
//           "",
//           "",
//           "",
//           "",
//           "",
//           (totals.mrp || 0).toFixed(2),
//           (totals.qty || 0).toFixed(2),
//           (totals.tax || 0).toFixed(2),
//           (totals.cgst || 0).toFixed(2),
//           (totals.sgst || 0).toFixed(2),
//           (totals.tax_row_value || 0).toFixed(2),
//           (totals.total || 0).toFixed(2),
//         ]
//           .map((val) => `<td>${val}</td>`)
//           .join("") +
//         "</tr>";
//     }

//     if (activeTab === "stockManagement") {
//       const totals = getStockManagementTotals();
//       excelContent +=
//         "<tr>" +
//         [
//           "",
//           "",
//           "",
//           "",
//           "",
//           "",
//           "",
//           "",
//           (totals.totalPurchasePrice || 0).toFixed(2),
//           (totals.totalMrp || 0).toFixed(2),
//           (totals.totalProfit || 0).toFixed(2),
//         ]
//           .map((val) => `<td>${val}</td>`)
//           .join("") +
//         "</tr>";
//     }

//     if (activeTab === "purchasePharmacy") {
//       const totals = getPurchasePharmacyTotals();
//       excelContent +=
//         "<tr>" +
//         [
//           "",
//           "",
//           "",
//           "",
//           "",
//           "",
//           "",
//           "",
//           "",
//           "",
//           totals.quantity || 0,
//           (totals.tax || 0).toFixed(2),
//           (totals.mrp || 0).toFixed(2),
//           (totals.total || 0).toFixed(2),
//         ]
//           .map((val) => `<td>${val}</td>`)
//           .join("") +
//         "</tr>";
//     }

//     excelContent += "</table>";

//     const blob = new Blob([excelContent], { type: "application/vnd.ms-excel" });
//     const url = window.URL.createObjectURL(blob);
//     const a = document.createElement("a");
//     a.href = url;
//     a.download = `${activeTab}_report.xls`;
//     a.click();
//     window.URL.revokeObjectURL(url);
//   };

//   const downloadPDF = () => {
//     const currentData = getFilteredData();
//     const config = tabConfig[activeTab];
//     const headers = config.headers;
//     const fields = ["sNo", ...config.fields];

//     const doc = new jsPDF();

//     doc.setFontSize(18);
//     doc.text(`${config.title} Report`, 14, 20);

//     doc.setFontSize(12);
//     doc.text(`Generated on: ${new Date().toLocaleDateString()}`, 14, 30);

//     const tableData = currentData.map((item) => fields.map((field) => item[field] || ""));

//     if (activeTab === "salePharmacy") {
//       const totals = getSalePharmacyTotals();
//       tableData.push([
//         "",
//         "",
//         "",
//         "",
//         "",
//         "",
//         "",
//         "",
//         "",
//         (totals.netTotal || 0).toFixed(2),
//         (totals.paid || 0).toFixed(2),
//         "",
//         (totals.profit || 0).toFixed(2),
//       ]);
//     }

//     if (activeTab === "salelist") {
//       const totals = getSaleListTotals();
//       tableData.push([
//         "",
//         "",
//         "",
//         "",
//         "",
//         "",
//         "",
//         "",
//         (totals.mrp || 0).toFixed(2),
//         (totals.qty || 0).toFixed(2),
//         (totals.tax || 0).toFixed(2),
//         (totals.cgst || 0).toFixed(2),
//         (totals.sgst || 0).toFixed(2),
//         (totals.tax_row_value || 0).toFixed(2),
//         (totals.total || 0).toFixed(2),
//       ]);
//     }

//     if (activeTab === "stockManagement") {
//       const totals = getStockManagementTotals();
//       tableData.push([
//         "",
//         "",
//         "",
//         "",
//         "",
//         "",
//         "",
//         "",
//         (totals.totalPurchasePrice || 0).toFixed(2),
//         (totals.totalMrp || 0).toFixed(2),
//         (totals.totalProfit || 0).toFixed(2),
//       ]);
//     }

//     if (activeTab === "purchasePharmacy") {
//       const totals = getPurchasePharmacyTotals();
//       tableData.push([
//         "",
//         "",
//         "",
//         "",
//         "",
//         "",
//         "",
//         "",
//         "",
//         "",
//         totals.quantity || 0,
//         (totals.tax || 0).toFixed(2),
//         (totals.mrp || 0).toFixed(2),
//         (totals.total || 0).toFixed(2),
//       ]);
//     }

//     autoTable(doc, {
//       startY: 40,
//       head: [headers],
//       body: tableData,
//       theme: "striped",
//       headStyles: {
//         fillColor: [46, 146, 144],
//         textColor: [255, 255, 255],
//         fontSize: 10,
//       },
//       bodyStyles: {
//         fontSize: 9,
//       },
//       alternateRowStyles: {
//         fillColor: [242, 242, 242],
//       },
//       margin: { top: 40 },
//     });

//     doc.save(`${activeTab}_report.pdf`);
//   };

//   const handlePrint = () => {
//     const currentData = getFilteredData();
//     const config = tabConfig[activeTab];
//     const headers = config.headers;
//     const fields = ["sNo", ...config.fields];

//     const printWindow = window.open("", "_blank");
//     let htmlContent = `
//       <html>
//         <head>
//           <title>${config.title} Report</title>
//           <style>
//             body { font-family: Arial, sans-serif; margin: 20px; }
//             h1 { color: #01AEBE; text-align: center; }
//             table { width: 100%; border-collapse: collapse; margin-top: 20px; }
//             th, td { border: 1px solid #ddd; padding: 8px; text-align: left; }
//             th { background-color: #01AEBE; color: white; }
//             tr:nth-child(even) { background-color: #f2f2f2; }
//             @media print {
//               body { margin: 0; }
//               h1 { margin-bottom: 20px; }
//             }
//           </style>
//         </head>
//         <body>
//           <h1>${config.title} Report</h1>
//           <p>Generated on: ${new Date().toLocaleDateString()}</p>
//           <table>
//             <thead>
//               <tr>${headers.map((h) => `<th>${h}</th>`).join("")}</tr>
//             </thead>
//             <tbody>
//               ${currentData
//         .map(
//           (item) =>
//             `<tr>${fields.map((field) => `<td>${item[field] || ""}</td>`).join("")}</tr>`
//         )
//         .join("")}
//               ${activeTab === "salePharmacy"
//         ? `<tr>${[
//           "",
//           "",
//           "",
//           "",
//           "",
//           "",
//           "",
//           "",
//           "",
//           (getSalePharmacyTotals().netTotal || 0).toFixed(2),
//           (getSalePharmacyTotals().paid || 0).toFixed(2),
//           "",
//           (getSalePharmacyTotals().profit || 0).toFixed(2),
//         ]
//           .map((val) => `<td><strong>${val}</strong></td>`)
//           .join("")}</tr>`
//         : ""
//       }
//               ${activeTab === "salelist"
//         ? `<tr>${[
//           "",
//           "",
//           "",
//           "",
//           "",
//           "",
//           "",
//           "",
//           (getSaleListTotals().mrp || 0).toFixed(2),
//           (getSaleListTotals().qty || 0).toFixed(2),
//           (getSaleListTotals().tax || 0).toFixed(2),
//           (getSaleListTotals().cgst || 0).toFixed(2),
//           (getSaleListTotals().sgst || 0).toFixed(2),
//           (getSaleListTotals().tax_row_value || 0).toFixed(2),
//           (getSaleListTotals().total || 0).toFixed(2),
//         ]
//           .map((val) => `<td><strong>${val}</strong></td>`)
//           .join("")}</tr>`
//         : ""
//       }
//               ${activeTab === "stockManagement"
//         ? `<tr>${[
//           "",
//           "",
//           "",
//           "",
//           "",
//           "",
//           "",
//           "",
//           (getStockManagementTotals().totalPurchasePrice || 0).toFixed(2),
//           (getStockManagementTotals().totalMrp || 0).toFixed(2),
//           (getStockManagementTotals().totalProfit || 0).toFixed(2),
//         ]
//           .map((val) => `<td><strong>${val}</strong></td>`)
//           .join("")}</tr>`
//         : ""
//       }
//               ${activeTab === "purchasePharmacy"
//         ? `<tr>${[
//           "",
//           "",
//           "",
//           "",
//           "",
//           "",
//           "",
//           "",
//           "",
//           "",
//           getPurchasePharmacyTotals().quantity || 0,
//           (getPurchasePharmacyTotals().tax || 0).toFixed(2),
//           (getPurchasePharmacyTotals().mrp || 0).toFixed(2),
//           (getPurchasePharmacyTotals().total || 0).toFixed(2),
//         ]
//           .map((val) => `<td><strong>${val}</strong></td>`)
//           .join("")}</tr>`
//         : ""
//       }
//             </tbody>
//           </table>
//         </body>
//       </html>
//     `;

//     printWindow.document.write(htmlContent);
//     printWindow.document.close();
//     printWindow.focus();
//     setTimeout(() => {
//       printWindow.print();
//       printWindow.close();
//     }, 250);
//   };

//   // Render table
//   const renderTable = () => {
//     const paginatedData = getPaginatedData();
//     const config = tabConfig[activeTab];
//     const fields = ["sNo", ...config.fields];

//     return (
//       <div className="table-responsive">
//         <table className="table table-bordered">
//           <thead>
//             <tr style={{ backgroundColor: "#01AEBE", color: "white" }}>
//               {config.headers.map((header, index) => (
//                 <th key={index} className="border-0">
//                   {header}
//                 </th>
//               ))}
//             </tr>
//           </thead>
//           <tbody>
//             {paginatedData.map((item, index) => (
//               <tr key={index} className="align-middle">
//                 {fields.map((field, fieldIndex) => (
//                   <td key={fieldIndex} className="border-0">
//                     {field === "order_status" ? (
//                       <span
//                         className={`d-inline-flex align-items-center gap-1 badge rounded-pill bg-success-subtle text-success fw-semibold px-3 py-2 ${getStatusBadgeClass(
//                           item[field]
//                         )}`}
//                         style={{ borderRadius: "1rem" }}
//                       >
//                         <FaCheckCircle />
//                         {item[field]}
//                       </span>
//                     ) : (
//                       item[field]
//                     )}
//                   </td>
//                 ))}
//               </tr>
//             ))}
//             {activeTab === "salePharmacy" && (
//               <tr style={{ backgroundColor: "#f2f2f2", fontWeight: "bold" }}>
//                 <td colSpan={9}>Totals</td>
//                 <td>{(getSalePharmacyTotals().netTotal || 0).toFixed(2)}</td>
//                 <td>{(getSalePharmacyTotals().paid || 0).toFixed(2)}</td>
//                 <td></td>
//                 <td>{(getSalePharmacyTotals().profit || 0).toFixed(2)}</td>
//               </tr>
//             )}
//             {activeTab === "salelist" && (
//               <tr style={{ backgroundColor: "#f2f2f2", fontWeight: "bold" }}>
//                 <td colSpan={8}>Totals</td>
//                 <td>{(getSaleListTotals().mrp || 0).toFixed(2)}</td>
//                 <td>{(getSaleListTotals().qty || 0).toFixed(2)}</td>
//                 <td>{(getSaleListTotals().tax || 0).toFixed(2)}</td>
//                 <td>{(getSaleListTotals().cgst || 0).toFixed(2)}</td>
//                 <td>{(getSaleListTotals().sgst || 0).toFixed(2)}</td>
//                 <td>{(getSaleListTotals().tax_row_value || 0).toFixed(2)}</td>
//                 <td>{(getSaleListTotals().total || 0).toFixed(2)}</td>
//               </tr>
//             )}
//             {activeTab === "stockManagement" && (
//               <tr style={{ backgroundColor: "#f2f2f2", fontWeight: "bold" }}>
//                 <td colSpan={8}>Totals</td>
//                 <td>{(getStockManagementTotals().totalPurchasePrice || 0).toFixed(2)}</td>
//                 <td>{(getStockManagementTotals().totalMrp || 0).toFixed(2)}</td>
//                 <td>{(getStockManagementTotals().totalProfit || 0).toFixed(2)}</td>
//               </tr>
//             )}
//             {activeTab === "purchasePharmacy" && (
//               <tr style={{ backgroundColor: "#f2f2f2", fontWeight: "bold" }}>
//                 <td colSpan={15}>Totals</td>
//                 <td>{getPurchasePharmacyTotals().quantity || 0}</td>
//                 <td>{(getPurchasePharmacyTotals().tax || 0).toFixed(2)}</td>
//                 <td>{(getPurchasePharmacyTotals().mrp || 0).toFixed(2)}</td>
//                 <td>{(getPurchasePharmacyTotals().total || 0).toFixed(2)}</td>
//               </tr>
//             )}
//           </tbody>
//         </table>
//       </div>
//     );
//   };

//   const getStatusBadgeClass = (status) => {
//     const statusClasses = {
//       Active: "bg-success",
//       Available: "bg-success",
//       Paid: "bg-success",
//       Completed: "bg-success",
//       Pending: "bg-warning",
//       "Low Stock": "bg-warning",
//       "Out of Stock": "bg-danger",
//     };
//     return statusClasses[status] || "bg-success";
//   };

//   // Render pagination
//   const renderPagination = () => {
//     const totalPages = getTotalPages();
//     if (totalPages <= 1) return null;

//     const pages = [];
//     const maxVisible = 5;
//     let startPage = Math.max(1, currentPage - Math.floor(maxVisible / 2));
//     let endPage = Math.min(totalPages, startPage + maxVisible - 1);

//     if (endPage - startPage + 1 < maxVisible) {
//       startPage = Math.max(1, endPage - maxVisible + 1);
//     }

//     for (let i = startPage; i <= endPage; i++) {
//       pages.push(i);
//     }

//     return (
//       <div className="d-flex justify-content-between align-items-center mt-3">
//         <div className="text-muted">
//           Showing {(currentPage - 1) * itemsPerPage + 1} to{" "}
//           {Math.min(currentPage * itemsPerPage, getFilteredData().length)} of{" "}
//           {getFilteredData().length} entries
//         </div>
//         <div className="d-flex gap-2">
//           <button
//             className="btn btn-outline-secondary btn-sm"
//             onClick={() => setCurrentPage(Math.max(1, currentPage - 1))}
//             disabled={currentPage === 1}
//           >
//             Previous
//           </button>
//           {pages.map((page) => (
//             <button
//               key={page}
//               className={`btn btn-sm ${currentPage === page ? "btn-success" : "btn-outline-secondary"}`}
//               onClick={() => setCurrentPage(page)}
//             >
//               {page}
//             </button>
//           ))}
//           <button
//             className="btn btn-outline-secondary btn-sm"
//             onClick={() => setCurrentPage(Math.min(totalPages, currentPage + 1))}
//             disabled={currentPage === totalPages}
//           >
//             Next
//           </button>
//         </div>
//       </div>
//     );
//   };

//   return (
//     <div className="container-fluid p-4" style={{ backgroundColor: "#f8f9fa", minHeight: "100vh" }}>
//       <div className="mb-4">
//         <ul className="nav nav-tabs flex-wrap">
//           {Object.entries(tabConfig).map(([key, config]) => (
//             <li key={key} className="nav-item">
//               <button
//                 className={`nav-link ${activeTab === key ? "active" : ""} px-3 py-2`}
//                 style={{
//                   backgroundColor: activeTab === key ? "#01AEBE" : "transparent",
//                   color: activeTab === key ? "white" : "#01AEBE",
//                   border: "1px solid #01AEBE",
//                   borderRadius: "0",
//                   fontSize: "14px",
//                 }}
//                 onClick={() => handleTabChange(key)}
//               >
//                 {config.title}
//               </button>
//             </li>
//           ))}
//         </ul>
//       </div>

//       <div className="card shadow-sm border-0">
//         <div className="card-header" style={{ backgroundColor: "#01AEBE", color: "white" }}>
//           <div className="row d-flex justify-content-between align-items-center">
//             <div className="col-lg-5 col-md-5 d-flex align-items-center">
//               <h5 className="mb-0 fw-bold">{tabConfig[activeTab]?.title}</h5>
//             </div>

//             <div className="col-lg-7 col-md-7 d-flex justify-content-center align-items-start gap-2 flex-wrap">
//               {["salePharmacy", "purchaseOrder", "purchasePharmacy", "salelist"].includes(activeTab) && (
//                 <>
//                   <div>
//                     <label className="form-label small mb-1 text-white">From Date:</label>
//                     <input
//                       type="date"
//                       className="form-control form-control-sm"
//                       value={fromDate}
//                       onChange={(e) => {
//                         setFromDate(e.target.value);
//                         setCurrentPage(1);
//                       }}
//                       max={toDate || undefined}
//                     />
//                   </div>

//                   <div>
//                     <label className="form-label small mb-1 text-white">To Date:</label>
//                     <input
//                       type="date"
//                       className="form-control form-control-sm"
//                       value={toDate}
//                       onChange={(e) => {
//                         setToDate(e.target.value);
//                         setCurrentPage(1);
//                       }}
//                       min={fromDate || undefined}
//                     />
//                   </div>

//                   {(fromDate || toDate) && (
//                     <div>
//                       <label className="form-label small mb-1 text-white">&nbsp;</label>
//                       <button
//                         className="btn btn-outline-light btn-sm w-100"
//                         onClick={() => {
//                           setFromDate("");
//                           setToDate("");
//                           setCurrentPage(1);
//                         }}
//                       >
//                         Clear Dates
//                       </button>
//                     </div>
//                   )}
//                 </>
//               )}

//               {activeTab === "salePharmacy" && (
//                 <>
//                   <div>
//                     <label className="form-label small mb-1 text-white">Paytype:</label>
//                     <select
//                       className="form-select form-select-sm"
//                       value={paymentMode}
//                       onChange={(e) => {
//                         setPaymentMode(e.target.value);
//                         setCurrentPage(1);
//                       }}
//                     >
//                       <option value="">All</option>
//                       <option value="Cash">Cash</option>
//                       <option value="Card">Card</option>
//                       <option value="Gpay">Gpay</option>
//                       <option value="Phonepe">Phonepe</option>
//                       <option value="Paytm">Paytm</option>
//                       <option value="Amazon Pay">Amazon Pay</option>
//                       <option value="UPI">UPI</option>
//                     </select>
//                   </div>

//                   <div>
//                     <label className="form-label small mb-1 text-white">Category:</label>
//                     <select
//                       className="form-select form-select-sm"
//                       value={category}
//                       onChange={(e) => {
//                         setCategory(e.target.value);
//                         setCurrentPage(1);
//                       }}
//                     >
//                       <option value="">All</option>
//                       <option value="Homeopathy">Homeopathy</option>
//                       <option value="Yoga">Yoga</option>
//                     </select>
//                   </div>
//                 </>
//               )}

//               {(activeTab === "medicineMaster" || activeTab === "stockManagement" || activeTab === "salelist") && (
//                 <>
//                   <div>
//                     <label className="form-label small mb-1 text-white">Category:</label>
//                     <select
//                       className="form-select form-select-sm"
//                       value={category}
//                       onChange={(e) => {
//                         setCategory(e.target.value);
//                         setCurrentPage(1);
//                       }}
//                     >
//                       <option value="">All</option>
//                       <option value="Homeopathy">Homeopathy</option>
//                       <option value="Yoga">Yoga</option>
//                     </select>
//                   </div>
//                 </>
//               )}
//             </div>
//           </div>

//           {fromDate && toDate && new Date(fromDate) > new Date(toDate) && (
//             <div className="text-danger small mt-1 text-end">From Date cannot be later than To Date</div>
//           )}
//         </div>

//         <div className="card-body">
//           <div className="row mb-3 align-items-center">
//             <div className="col-md-3">
//               <div className="input-group input-group-sm w-100">
//                 <span className="input-group-text">
//                   <i className="fas fa-table"></i>
//                 </span>
//                 <select
//                   className="form-select"
//                   value={itemsPerPage}
//                   onChange={(e) => {
//                     const value = e.target.value === "All" ? getFilteredData().length : Number(e.target.value);
//                     setItemsPerPage(value);
//                     setCurrentPage(1);
//                   }}
//                 >
//                   <option value="All">Show All</option>
//                   <option value="5">Show 5</option>
//                   <option value="10">Show 10</option>
//                   <option value="20">Show 20</option>
//                   <option value="50">Show 50</option>
//                   <option value="100">Show 100</option>
//                 </select>
//               </div>
//             </div>

//             <div className="col-md-6">
//               <div className="d-flex flex-wrap gap-2">
//                 <button
//                   className="btn btn-success btn-sm d-flex align-items-center gap-1"
//                   onClick={downloadPDF}
//                 >
//                   <FileText size={16} /> PDF
//                 </button>
//                 <button
//                   className="btn btn-success btn-sm d-flex align-items-center gap-1"
//                   onClick={downloadExcel}
//                 >
//                   <FileSpreadsheet size={16} /> Excel
//                 </button>
//                 <button
//                   className="btn btn-success btn-sm d-flex align-items-center gap-1"
//                   onClick={downloadCSV}
//                 >
//                   <Download size={16} /> CSV
//                 </button>
//                 <button
//                   className="btn btn-success btn-sm d-flex align-items-center gap-1"
//                   onClick={handlePrint}
//                 >
//                   <Printer size={16} /> Print
//                 </button>
//               </div>
//             </div>

//             <div className="col-md-3">
//               <div className="position-relative">
//                 <input
//                   type="text"
//                   className="form-control form-control-sm pe-5"
//                   placeholder="Search..."
//                   value={searchTerm}
//                   onChange={(e) => {
//                     setSearchTerm(e.target.value);
//                     setCurrentPage(1);
//                   }}
//                 />
//                 <Search
//                   size={16}
//                   className="position-absolute text-muted"
//                   style={{ right: "10px", top: "50%", transform: "translateY(-50%)" }}
//                 />
//               </div>
//             </div>
//           </div>

//           {isLoading ? (
//             <div className="text-center">
//               <div className="spinner-border text-success" role="status">
//                 <span className="visually-hidden">Loading...</span>
//               </div>
//             </div>
//           ) : (
//             <>
//               {renderTable()}
//               {renderPagination()}
//             </>
//           )}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default ReportPharmacy;


// import React, { useEffect, useState } from "react";
// import {
//   Search,
//   Download,
//   Printer,
//   FileSpreadsheet,
//   FileText,
// } from "lucide-react";

// import { FaCheckCircle } from "react-icons/fa";
// import jsPDF from "jspdf";
// import autoTable from "jspdf-autotable";
// import axios from "axios";
// import Apiurl from "./../../environment/Apiurl";

// const ReportPharmacy = () => {
//   const [activeTab, setActiveTab] = useState("medicineMaster");
//   const [searchTerm, setSearchTerm] = useState("");
//   const [currentPage, setCurrentPage] = useState(1);
//   const [itemsPerPage, setItemsPerPage] = useState(5);
//   const [fromDate, setFromDate] = useState("");
//   const [toDate, setToDate] = useState("");
//   const [paymentMode, setPaymentMode] = useState("");
//   const [category, setCategory] = useState("");
//   const [isLoading, setIsLoading] = useState(false);

//   const [medicineMasterData, setMedicineMasterData] = useState([]);
//   const [purchaseOrderData, setPurchaseOrderData] = useState([]);
//   const [purchaseListData, setPurchaseListData] = useState([]);
//   const [salePharmacyData, setSalesPharmacyData] = useState([]);
//   const [salelist, setSaleslist] = useState([]);
//   const [stockPharmacyData, setStockPharmacyData] = useState([]);

//   // ==================== FETCH FUNCTIONS ====================
//   const fetchMedicineMasterData = async () => {
//     setIsLoading(true);
//     try {
//       const response = await axios.get(`${Apiurl}/medicine_master`);
//       setMedicineMasterData(response.data || []);
//     } catch (error) {
//       console.error("Error fetching Medicine Master data:", error.message);
//       setMedicineMasterData([]);
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   const fetchPurchaseOrderData = async () => {
//     setIsLoading(true);
//     try {
//       const response = await axios.get(`${Apiurl}/purchase_order`);
//       setPurchaseOrderData(response.data || []);
//     } catch (error) {
//       console.error("Error fetching Purchase Order data:", error.message);
//       setPurchaseOrderData([]);
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   const fetchPurchaseListData = async () => {
//     setIsLoading(true);
//     try {
//       const response = await axios.get(`${Apiurl}/purchase_pharmacy_list`);
//       setPurchaseListData(response.data || []);
//     } catch (error) {
//       console.error("Error fetching Purchase Pharmacy data:", error.message);
//       setPurchaseListData([]);
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   const fetchSalePharmacyData = async () => {
//     setIsLoading(true);
//     try {
//       const response = await axios.get(`${Apiurl}/sale`);
//       setSalesPharmacyData(response.data || []);
//     } catch (error) {
//       console.error("Error fetching Sale Pharmacy data:", error.message);
//       setSalesPharmacyData([]);
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   const fetchSalelist = async () => {
//     setIsLoading(true);
//     try {
//       const response = await axios.get(`${Apiurl}/sale_list_data`);
//       setSaleslist(response.data || []);
//     } catch (error) {
//       console.error("Error fetching Sale List data:", error.message);
//       setSaleslist([]);
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   const fetchStockPharmacyData = async () => {
//     setIsLoading(true);
//     try {
//       const response = await axios.get(`${Apiurl}/stock_pharmacy`);
//       setStockPharmacyData(response.data || []);
//     } catch (error) {
//       console.error("Error fetching Stock Pharmacy data:", error.message);
//       setStockPharmacyData([]);
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   useEffect(() => {
//     window.scrollTo({ top: 0, behavior: "smooth" });
//   }, []);

//   useEffect(() => {
//     fetchMedicineMasterData();
//     fetchPurchaseOrderData();
//     fetchPurchaseListData();
//     fetchSalePharmacyData();
//     fetchSalelist();
//     fetchStockPharmacyData();
//   }, []);

//   // ==================== TAB CONFIG ====================
//   const tabConfig = {
//     medicineMaster: {
//       title: "Medicine Master",
//       headers: ["S.No", "Medicine", "Category", "Medicine Type", "Manufacturer", "HSN Code"],
//       fields: ["medicine_name", "category", "medicine_type", "manufacturer", "hsn_code"],
//       data: medicineMasterData,
//     },
//     purchaseOrder: {
//       title: "Purchase Order",
//       headers: ["S.No", "Date", "Pur Order No", "Supplier Name", "Order Status"],
//       fields: ["date", "purchase_order_no", "supplier_details[0].supplier_name", "order_status"],
//       data: purchaseOrderData,
//     },
//     purchasePharmacy: {
//       title: "Purchase Product List",
//       headers: [
//         "S.No", "Purchase Date", "Invoice No", "Supplier ID", "Supplier ",
//         "Medicine", "Category", "HSN", "Batch No", "Unit Pack",
//         "Pur Price", "Qty", "Taxable", "Discount", "Tax(%)",
//         "CGST", "SGST", "Tax Value", "Amount (₹)",
//       ],
//       fields: [
//         "purchase_date", "invoice_number", "supplier_id", "supplier_name",
//         "medicine_name", "category", "hsn_code", "batch_no", "unit_pack",
//         "purchase_price", "quantity", "", "discount_per_tablet", "gst_percentage",
//         "", "", "tax", "total",
//       ],
//       data: purchaseListData,
//     },
//     salePharmacy: {
//       title: "Sale Pharmacy",
//       headers: [
//         "S.No", "Sale Date", "Invoice No", "Patient ID", "Patient Name",
//         "Category", "Pur Price", "MRP", "Qty", "Net Total",
//         "Paid (Breakdown)", "PayType", "Profit",
//       ],
//       fields: [
//         "sale_date", "invoice_number", "patient_id",
//         "patient_details[0].first_name", "patient_details[0].patient_type",
//         "sales_list[0].purchase_price_per_unit", "sales_list[0].mrp",
//         "sales_list[0].quantity", "net_total", "paid",
//         "sales_pharmacy_payment[0].pay_type", "profit",
//       ],
//       data: salePharmacyData,
//     },
//     salelist: {
//       title: "Sales Product List",
//       headers: [
//         "S.No", "Sale Date", "Invoice No", "Patient ID", "Patient Name",
//         "Medicine Name", "HSN Code", "Category", "MRP", "Qty",
//         "Tax(%)", "CGST", "SGST", "Tax Value", "Total",
//       ],
//       fields: [
//         "sale_date", "invoice_number", "patient_id", "patient_name",
//         "medicine_name", "hsn_code", "category", "mrp", "qty",
//         "tax", "cgst", "sgst", "tax_row_value", "total",
//       ],
//       data: salelist,
//     },
//     stockManagement: {
//       title: "Stock Management",
//       headers: [
//         "S.No", "Medicine", "Category", "Batch No", "Exp Date",
//         "InQty", "OutQty", "Balance", "Pur Price", "MRP", "Profit",
//       ],
//       fields: [
//         "medicine_details.medicine_name", "medicine_details.category",
//         "batch_no", "expiry_date", "inward_quantity", "outward_quantity",
//         "balance_quantity", "purchase_price", "mrp", "profit",
//       ],
//       data: stockPharmacyData,
//     },
//   };

//   // ==================== HELPER: NESTED VALUE ====================
//   const getNestedValue = (obj, path) => {
//     if (!obj) return "N/A";

//     // ---- PROFIT (salePharmacy) ----
//     if (path === "profit" && activeTab === "salePharmacy") {
//       if (!obj.sales_list || !Array.isArray(obj.sales_list)) return "0.00";
//       return obj.sales_list
//         .reduce((sum, sl) => sum + (parseFloat(sl.profit) || 0), 0)
//         .toFixed(2);
//     }

//     // ---- PAYTYPE (multiple) ----
//     if (path === "sales_pharmacy_payment[0].pay_type") {
//       const payments = Array.isArray(obj.sales_pharmacy_payment) ? obj.sales_pharmacy_payment : [];
//       if (paymentMode) {
//         return payments.some(p => p.pay_type === paymentMode) ? paymentMode : "N/A";
//       }
//       return payments.map(p => p.pay_type).join(", ") || "N/A";
//     }

//     // ---- PAID (breakdown) ----
//     if (path === "paid" && activeTab === "salePharmacy") {
//       const payments = Array.isArray(obj.sales_pharmacy_payment) ? obj.sales_pharmacy_payment : [];
//       if (paymentMode) {
//         const amount = payments
//           .filter(p => p.pay_type === paymentMode)
//           .reduce((s, p) => s + (parseFloat(p.paid_amount) || 0), 0);
//         return amount > 0 ? `${paymentMode}: ${amount.toFixed(2)}` : "0.00";
//       } else {
//         const breakdown = payments
//           .map(p => `${p.pay_type}: ${parseFloat(p.paid_amount || 0).toFixed(2)}`)
//           .join(", ");
//         return breakdown || "0.00";
//       }
//     }

//     // ---- STOCK PROFIT ----
//     if (activeTab === "stockManagement" && path === "profit") {
//       const { profit } = calculateStockValues(obj);
//       return profit;
//     }

//     // ---- NUMERIC FORMATTING (salelist, purchasePharmacy) ----
//     if (
//       ["salelist", "purchasePharmacy"].includes(activeTab) &&
//       ["mrp", "qty", "tax", "cgst", "sgst", "tax_row_value", "total"].includes(path)
//     ) {
//       const v = parseFloat(obj[path]);
//       return isNaN(v) ? "0.00" : v.toFixed(2);
//     }

//     // ---- GENERAL NESTED ----
//     const parts = path.match(/(\w+|\[\d+\])/g) || [path];
//     let current = obj;
//     for (let part of parts) {
//       if (part.startsWith("[") && part.endsWith("]")) {
//         const idx = parseInt(part.slice(1, -1));
//         current = current ? current[idx] : undefined;
//       } else {
//         current = current ? current[part] : undefined;
//       }
//       if (!current) break;
//     }

//     if (["sub_total", "net_total", "discount_value", "paid", "purchase_price", "mrp"].includes(path.split(".").pop())) {
//       const v = parseFloat(current);
//       return isNaN(v) ? "0.00" : v.toFixed(2);
//     }

//     return current ?? "N/A";
//   };

//   // ==================== STOCK CALCULATION ====================
//   const calculateStockValues = (item) => {
//     const purchasePrice = parseFloat(item.purchase_price) || 0;
//     const mrp = parseFloat(item.mrp) || 0;
//     let tabletsPerPack = 1;

//     if (typeof item.unit_pack === "string" && item.unit_pack.includes("*")) {
//       const parts = item.unit_pack.split("*").map(p => parseInt(p.trim()));
//       if (parts.length === 2 && !isNaN(parts[1])) tabletsPerPack = parts[1];
//     }

//     const perTabletPrice = tabletsPerPack > 0 ? purchasePrice / tabletsPerPack : 0;
//     const perTabletMrp = tabletsPerPack > 0 ? mrp / tabletsPerPack : 0;
//     const profit = parseFloat(item.profit) || 0;

//     return {
//       perTabletPrice: perTabletPrice.toFixed(2),
//       perTabletMrp: perTabletMrp.toFixed(2),
//       profit: profit.toFixed(2),
//     };
//   };

//   // ==================== DATA FILTERING ====================
//   const getCurrentData = () => {
//     const config = tabConfig[activeTab];
//     if (!config) return [];

//     let filteredData = config.data || [];

//     // Category filter
//     if (["medicineMaster", "stockManagement"].includes(activeTab) && category) {
//       filteredData = filteredData.filter(item => {
//         if (activeTab === "medicineMaster") return item.category === category;
//         return item.medicine_details?.category === category;
//       });
//     }

//     // Date filters
//     if (["salePharmacy", "salelist", "purchaseOrder", "purchasePharmacy"].includes(activeTab) && (fromDate || toDate)) {
//       filteredData = filteredData.filter(item => {
//         const itemDate = new Date(item.sale_date || item.purchase_date || item.date);
//         if (isNaN(itemDate)) return false;

//         let ok = true;
//         if (fromDate) {
//           const from = new Date(fromDate); from.setHours(0, 0, 0, 0);
//           const d = new Date(itemDate); d.setHours(0, 0, 0, 0);
//           ok = ok && d >= from;
//         }
//         if (toDate && ok) {
//           const to = new Date(toDate); to.setHours(23, 59, 59, 999);
//           const d = new Date(itemDate); d.setHours(23, 59, 59, 999);
//           ok = ok && d <= to;
//         }
//         return ok;
//       });
//     }

//     // Paytype filter
//     if (activeTab === "salePharmacy" && paymentMode) {
//       filteredData = filteredData.filter(item =>
//         Array.isArray(item.sales_pharmacy_payment) &&
//         item.sales_pharmacy_payment.some(p => p.pay_type === paymentMode)
//       );
//     }

//     // Category filter for salePharmacy
//     if (activeTab === "salePharmacy" && category) {
//       filteredData = filteredData.filter(item =>
//         item.patient_details?.[0]?.patient_type === category
//       );
//     }

//     return filteredData.map((item, idx) => {
//       const row = { sNo: idx + 1 };
//       config.fields.forEach(f => {
//         row[f] = getNestedValue(item, f);
//       });
//       return row;
//     });
//   };

//   const getFilteredData = () => {
//     const data = getCurrentData();
//     if (!searchTerm) return data;
//     return data.filter(item =>
//       Object.values(item).some(v =>
//         v?.toString().toLowerCase().includes(searchTerm.toLowerCase())
//       )
//     );
//   };

//   const getPaginatedData = () => {
//     const data = getFilteredData();
//     const start = (currentPage - 1) * itemsPerPage;
//     return data.slice(start, start + itemsPerPage);
//   };

//   const getTotalPages = () => Math.ceil(getFilteredData().length / itemsPerPage);

//   // ==================== TOTALS ====================
//   const getSalePharmacyTotals = () => {
//     if (activeTab !== "salePharmacy") return { netTotal: 0, paid: 0, profit: 0 };

//     const data = getFilteredData();
//     return data.reduce((acc, item) => {
//       const netTotal = parseFloat(item.net_total) || 0;
//       const profit = parseFloat(item.profit) || 0;
//       let paid = 0;

//       const orig = salePharmacyData.find(
//         o => o.sale_date === item.sale_date && o.invoice_number === item.invoice_number
//       );

//       if (orig && Array.isArray(orig.sales_pharmacy_payment)) {
//         const payments = orig.sales_pharmacy_payment;
//         if (paymentMode) {
//           paid = payments
//             .filter(p => p.pay_type === paymentMode)
//             .reduce((s, p) => s + (parseFloat(p.paid_amount) || 0), 0);
//         } else {
//           paid = payments.reduce((s, p) => s + (parseFloat(p.paid_amount) || 0), 0);
//         }
//       }

//       return {
//         netTotal: acc.netTotal + netTotal,
//         paid: acc.paid + paid,
//         profit: acc.profit + profit,
//       };
//     }, { netTotal: 0, paid: 0, profit: 0 });
//   };

//   const getSaleListTotals = () => {
//     if (activeTab !== "salelist") return { mrp: 0, qty: 0, tax: 0, cgst: 0, sgst: 0, tax_row_value: 0, total: 0 };
//     const data = getFilteredData();
//     return data.reduce((acc, item) => ({
//       mrp: acc.mrp + (parseFloat(item.mrp) || 0),
//       qty: acc.qty + (parseFloat(item.qty) || 0),
//       tax: acc.tax + (parseFloat(item.tax) || 0),
//       cgst: acc.cgst + (parseFloat(item.cgst) || 0),
//       sgst: acc.sgst + (parseFloat(item.sgst) || 0),
//       tax_row_value: acc.tax_row_value + (parseFloat(item.tax_row_value) || 0),
//       total: acc.total + (parseFloat(item.total) || 0),
//     }), { mrp: 0, qty: 0, tax: 0, cgst: 0, sgst: 0, tax_row_value: 0, total: 0 });
//   };

//   const getStockManagementTotals = () => {
//     if (activeTab !== "stockManagement") return { totalPurchasePrice: 0, totalMrp: 0, totalProfit: 0 };
//     const data = getFilteredData();
//     return data.reduce((acc, item) => ({
//       totalPurchasePrice: acc.totalPurchasePrice + (parseFloat(item.purchase_price) || 0),
//       totalMrp: acc.totalMrp + (parseFloat(item.mrp) || 0),
//       totalProfit: acc.totalProfit + (parseFloat(item.profit) || 0),
//     }), { totalPurchasePrice: 0, totalMrp: 0, totalProfit: 0 });
//   };

//   const getPurchasePharmacyTotals = () => {
//     if (activeTab !== "purchasePharmacy") return { quantity: 0, tax: 0, mrp: 0, total: 0 };
//     const data = getFilteredData();
//     return data.reduce((acc, item) => ({
//       quantity: acc.quantity + (parseInt(item.quantity) || 0),
//       tax: acc.tax + (parseFloat(item.tax) || 0),
//       mrp: acc.mrp + (parseFloat(item.mrp) || 0),
//       total: acc.total + (parseFloat(item.total) || 0),
//     }), { quantity: 0, tax: 0, mrp: 0, total: 0 });
//   };

//   // ==================== EXPORT HELPERS ====================
//   const buildExportRow = (item, fields, config) => {
//     const row = {};
//     fields.forEach(f => {
//       if (f === "paid" && activeTab === "salePharmacy") {
//         const payments = Array.isArray(item.sales_pharmacy_payment) ? item.sales_pharmacy_payment : [];
//         if (paymentMode) {
//           const amt = payments
//             .filter(p => p.pay_type === paymentMode)
//             .reduce((s, p) => s + (parseFloat(p.paid_amount) || 0), 0);
//           row[f] = amt > 0 ? `${paymentMode}: ${amt.toFixed(2)}` : "0.00";
//         } else {
//           row[f] = payments
//             .map(p => `${p.pay_type}: ${parseFloat(p.paid_amount || 0).toFixed(2)}`)
//             .join(", ") || "0.00";
//         }
//       } else {
//         row[f] = getNestedValue(item, f);
//       }
//     });
//     return row;
//   };

//   // ==================== EXPORTS ====================
//   const downloadCSV = () => {
//     const data = getFilteredData();
//     const config = tabConfig[activeTab];
//     const fields = ["sNo", ...config.fields];
//     let csv = config.headers.join(",") + "\n";

//     data.forEach(item => {
//       const row = buildExportRow(item, config.fields, config);
//       const line = fields.map(f => `"${row[f] || ""}"`).join(",");
//       csv += line + "\n";
//     });

//     // TOTALS
//     if (activeTab === "salePharmacy") {
//       const t = getSalePharmacyTotals();
//       const totalLine = [
//         "", "", "", "", "", "", "", "", "",
//         t.netTotal.toFixed(2),
//         paymentMode ? `${paymentMode}: ${t.paid.toFixed(2)}` : `Total: ${t.paid.toFixed(2)}`,
//         "", t.profit.toFixed(2)
//       ];
//       csv += totalLine.join(",") + "\n";
//     }
//     // ... other totals (same as before)

//     const blob = new Blob([csv], { type: "text/csv" });
//     const url = URL.createObjectURL(blob);
//     const a = document.createElement("a");
//     a.href = url; a.download = `${activeTab}_report.csv`; a.click();
//     URL.revokeObjectURL(url);
//   };

//   const downloadExcel = () => {
//     const data = getFilteredData();
//     const config = tabConfig[activeTab];
//     const fields = ["sNo", ...config.fields];
//     let html = '<table border="1"><tr>' + config.headers.map(h => `<th>${h}</th>`).join("") + '</tr>';

//     data.forEach(item => {
//       const row = buildExportRow(item, config.fields, config);
//       html += '<tr>' + fields.map(f => `<td>${row[f] || ""}</td>`).join("") + '</tr>';
//     });

//     // TOTALS (same logic as CSV)
//     if (activeTab === "salePharmacy") {
//       const t = getSalePharmacyTotals();
//       html += '<tr>' + [
//         "", "", "", "", "", "", "", "", "",
//         t.netTotal.toFixed(2),
//         paymentMode ? `${paymentMode}: ${t.paid.toFixed(2)}` : `Total: ${t.paid.toFixed(2)}`,
//         "", t.profit.toFixed(2)
//       ].map(v => `<td>${v}</td>`).join("") + '</tr>';
//     }

//     html += '</table>';
//     const blob = new Blob([html], { type: "application/vnd.ms-excel" });
//     const url = URL.createObjectURL(blob);
//     const a = document.createElement("a");
//     a.href = url; a.download = `${activeTab}_report.xls`; a.click();
//     URL.revokeObjectURL(url);
//   };

//   const downloadPDF = () => {
//     const data = getFilteredData();
//     const config = tabConfig[activeTab];
//     const fields = ["sNo", ...config.fields];
//     const doc = new jsPDF();

//     doc.setFontSize(18);
//     doc.text(`${config.title} Report`, 14, 20);
//     doc.setFontSize(12);
//     doc.text(`Generated on: ${new Date().toLocaleDateString()}`, 14, 30);

//     const body = data.map(item => {
//       const row = buildExportRow(item, config.fields, config);
//       return fields.map(f => row[f] || "");
//     });

//     // TOTALS
//     if (activeTab === "salePharmacy") {
//       const t = getSalePharmacyTotals();
//       body.push([
//         "", "", "", "", "", "", "", "", "",
//         t.netTotal.toFixed(2),
//         paymentMode ? `${paymentMode}: ${t.paid.toFixed(2)}` : `Total: ${t.paid.toFixed(2)}`,
//         "", t.profit.toFixed(2)
//       ]);
//     }

//     autoTable(doc, {
//       startY: 40,
//       head: [config.headers],
//       body,
//       theme: "striped",
//       headStyles: { fillColor: [46, 146, 144], textColor: [255, 255, 255] },
//     });

//     doc.save(`${activeTab}_report.pdf`);
//   };

//   const handlePrint = () => {
//     const data = getFilteredData();
//     const config = tabConfig[activeTab];
//     const fields = ["sNo", ...config.fields];

//     const printWin = window.open("", "_blank");
//     let html = `
//       <html><head><title>${config.title} Report</title>
//       <style>
//         body{font-family:Arial;margin:20px;}
//         h1{color:#01AEBE;text-align:center;}
//         table{width:100%;border-collapse:collapse;margin-top:20px;}
//         th,td{border:1px solid #ddd;padding:8px;text-align:left;}
//         th{background:#01AEBE;color:white;}
//         tr:nth-child(even){background:#f2f2f2;}
//       </style>
//       </head><body>
//       <h1>${config.title} Report</h1>
//       <p>Generated on: ${new Date().toLocaleDateString()}</p>
//       <table><thead><tr>${config.headers.map(h => `<th>${h}</th>`).join("")}</tr></thead><tbody>
//     `;

//     data.forEach(item => {
//       const row = buildExportRow(item, config.fields, config);
//       html += `<tr>${fields.map(f => `<td>${row[f] || ""}</td>`).join("")}</tr>`;
//     });

//     if (activeTab === "salePharmacy") {
//       const t = getSalePharmacyTotals();
//       html += `<tr>${[
//         "", "", "", "", "", "", "", "", "",
//         t.netTotal.toFixed(2),
//         paymentMode ? `${paymentMode}: ${t.paid.toFixed(2)}` : `Total: ${t.paid.toFixed(2)}`,
//         "", t.profit.toFixed(2)
//       ].map(v => `<td><strong>${v}</strong></td>`).join("")}</tr>`;
//     }

//     html += `</tbody></table></body></html>`;
//     printWin.document.write(html);
//     printWin.document.close();
//     setTimeout(() => { printWin.print(); printWin.close(); }, 250);
//   };

//   // ==================== RENDER TABLE ====================
//   const renderTable = () => {
//     const data = getPaginatedData();
//     const config = tabConfig[activeTab];
//     const fields = ["sNo", ...config.fields];

//     return (
//       <div className="table-responsive">
//         <table className="table table-bordered">
//           <thead>
//             <tr style={{ backgroundColor: "#01AEBE", color: "white" }}>
//               {config.headers.map((h, i) => <th key={i}>{h}</th>)}
//             </tr>
//           </thead>
//           <tbody>
//             {data.map((item, idx) => (
//               <tr key={idx}>
//                 {fields.map((f, i) => (
//                   <td key={i}>
//                     {f === "order_status" ? (
//                       <span className={`badge rounded-pill ${getStatusBadgeClass(item[f])}`}>
//                         <FaCheckCircle /> {item[f]}
//                       </span>
//                     ) : (
//                       item[f]
//                     )}
//                   </td>
//                 ))}
//               </tr>
//             ))}

//             {/* TOTALS ROWS */}
//             {activeTab === "salePharmacy" && (
//               <tr style={{ backgroundColor: "#f2f2f2", fontWeight: "bold" }}>
//                 <td colSpan={9}>Totals</td>
//                 <td>{getSalePharmacyTotals().netTotal.toFixed(2)}</td>
//                 <td>
//                   {paymentMode
//                     ? `${paymentMode}: ${getSalePharmacyTotals().paid.toFixed(2)}`
//                     : `Total: ${getSalePharmacyTotals().paid.toFixed(2)}`}
//                 </td>
//                 <td></td>
//                 <td>{getSalePharmacyTotals().profit.toFixed(2)}</td>
//               </tr>
//             )}
//             {/* other totals unchanged */}
//           </tbody>
//         </table>
//       </div>
//     );
//   };

//   const getStatusBadgeClass = (status) => {
//     const map = {
//       Active: "bg-success", Available: "bg-success", Paid: "bg-success",
//       Completed: "bg-success", Pending: "bg-warning", "Low Stock": "bg-warning",
//       "Out of Stock": "bg-danger",
//     };
//     return map[status] || "bg-success";
//   };

//   // ==================== PAGINATION ====================
//   const renderPagination = () => {
//     const total = getTotalPages();
//     if (total <= 1) return null;
//     const pages = [];
//     const max = 5;
//     let start = Math.max(1, currentPage - Math.floor(max / 2));
//     let end = Math.min(total, start + max - 1);
//     if (end - start + 1 < max) start = Math.max(1, end - max + 1);
//     for (let i = start; i <= end; i++) pages.push(i);

//     return (
//       <div className="d-flex justify-content-between align-items-center mt-3">
//         <div className="text-muted">
//           Showing {(currentPage - 1) * itemsPerPage + 1} to{" "}
//           {Math.min(currentPage * itemsPerPage, getFilteredData().length)} of{" "}
//           {getFilteredData().length} entries
//         </div>
//         <div className="d-flex gap-2">
//           <button className="btn btn-outline-secondary btn-sm" onClick={() => setCurrentPage(Math.max(1, currentPage - 1))} disabled={currentPage === 1}>Previous</button>
//           {pages.map(p => (
//             <button key={p} className={`btn btn-sm ${currentPage === p ? "btn-success" : "btn-outline-secondary"}`} onClick={() => setCurrentPage(p)}>{p}</button>
//           ))}
//           <button className="btn btn-outline-secondary btn-sm" onClick={() => setCurrentPage(Math.min(total, currentPage + 1))} disabled={currentPage === total}>Next</button>
//         </div>
//       </div>
//     );
//   };

//   // ==================== TAB CHANGE ====================
//   const handleTabChange = (key) => {
//     setActiveTab(key);
//     setCurrentPage(1);
//     setSearchTerm("");
//     setFromDate("");
//     setToDate("");
//     setPaymentMode("");
//     setCategory("");
//   };

//   // ==================== RETURN JSX ====================
//   return (
//     <div className="container-fluid p-4" style={{ backgroundColor: "#f8f9fa", minHeight: "100vh" }}>
//       {/* TABS */}
//       <div className="mb-4">
//         <ul className="nav nav-tabs flex-wrap">
//           {Object.entries(tabConfig).map(([k, c]) => (
//             <li key={k} className="nav-item">
//               <button
//                 className={`nav-link ${activeTab === k ? "active" : ""} px-3 py-2`}
//                 style={{
//                   backgroundColor: activeTab === k ? "#01AEBE" : "transparent",
//                   color: activeTab === k ? "white" : "#01AEBE",
//                   border: "1px solid #01AEBE",
//                   borderRadius: "0",
//                   fontSize: "14px",
//                 }}
//                 onClick={() => handleTabChange(k)}
//               >
//                 {c.title}
//               </button>
//             </li>
//           ))}
//         </ul>
//       </div>

//       {/* <div className="card shadow-sm border-0">
//         <div className="card-header" style={{ backgroundColor: "#01AEBE", color: "white" }}>

//         </div> */}

// <div className="card shadow-sm border-0">
//   <div className="card-header" style={{ backgroundColor: "#01AEBE", color: "white" }}>
//     <div className="row d-flex justify-content-between align-items-center">
//       <div className="col-lg-5 col-md-5 d-flex align-items-center">
//         <h5 className="mb-0 fw-bold">{tabConfig[activeTab]?.title}</h5>
//       </div>

//       <div className="col-lg-7 col-md-7 d-flex justify-content-center align-items-start gap-2 flex-wrap">
//         <>
//           {["salePharmacy", "purchaseOrder", "purchasePharmacy", "salelist"].includes(activeTab) && (
//             <>
//               <div>
//                 <label className="form-label small mb-1 text-white">From Date:</label>
//                 <input
//                   type="date"
//                   className="form-control form-control-sm"
//                   value={fromDate}
//                   onChange={(e) => {
//                     setFromDate(e.target.value);
//                     setCurrentPage(1);
//                   }}
//                   max={toDate || undefined}
//                 />
//               </div>

//               <div>
//                 <label className="form-label small mb-1 text-white">To Date:</label>
//                 <input
//                   type="date"
//                   className="form-control form-control-sm"
//                   value={toDate}
//                   onChange={(e) => {
//                     setToDate(e.target.value);
//                     setCurrentPage(1);
//                   }}
//                   min={fromDate || undefined}
//                 />
//               </div>

//               {(fromDate || toDate) && (
//                 <div>
//                   <label className="form-label small mb-1 text-white">&nbsp;</label>
//                   <button
//                     className="btn btn-outline-light btn-sm w-100"
//                     onClick={() => {
//                       setFromDate("");
//                       setToDate("");
//                       setCurrentPage(1);
//                     }}
//                   >
//                     Clear Dates
//                   </button>
//                 </div>
//               )}
//             </>
//           )}

//           {activeTab === "salePharmacy" && (
//             <>
//               <div>
//                 <label className="form-label small mb-1 text-white">Paytype:</label>
//                 <select
//                   className="form-select form-select-sm"
//                   value={paymentMode}
//                   onChange={(e) => {
//                     setPaymentMode(e.target.value);
//                     setCurrentPage(1);
//                   }}
//                 >
//                   <option value="">All</option>
//                   <option value="Cash">Cash</option>
//                   <option value="Card">Card</option>
//                   <option value="Gpay">Gpay</option>
//                   <option value="Phonepe">Phonepe</option>
//                   <option value="Paytm">Paytm</option>
//                   <option value="Amazon Pay">Amazon Pay</option>
//                   <option value="UPI">UPI</option>
//                 </select>
//               </div>
//             </>
//           )}

//           {(activeTab === "medicineMaster" ||
//             activeTab === "stockManagement" ) && (
//             <>
//               <div>
//                 <label className="form-label small mb-1 text-white">Category:</label>
//                 <select
//                   className="form-select form-select-sm"
//                   value={category}
//                   onChange={(e) => {
//                     setCategory(e.target.value);
//                     setCurrentPage(1);
//                   }}
//                 >
//                   <option value="">All</option>
//                   <option value="Homeopathy">Homeopathy</option>
//                   <option value="Yoga">Yoga</option>
//                 </select>
//               </div>
//             </>
//           )}


//            {activeTab === "salelist" && (
//                 <div>
//                   <label className="form-label small mb-1 text-white">Category:</label>
//                   <select className="form-select form-select-sm" value={category} onChange={e => { setCategory(e.target.value); setCurrentPage(1); }}>
//                     <option value="">All</option>
//                     {["Tablet", "Capsule", "Syrup", "Injection", "Powder", "Sachet", "Cream", "Ointment", "Gel", "Drops", "Inhaler", "Suppository", "Suspension", "Spray", "Lotion", "Solution", "Patch", "Dispersible Tablet", "Chewable Tablet", "IV Fluid"].map(c => (
//                       <option key={c} value={c}>{c}</option>
//                     ))}
//                   </select>
//                 </div>
//               )}
//         </>
//       </div>
//     </div>

//     {fromDate && toDate && new Date(fromDate) > new Date(toDate) && (
//       <div className="text-danger small mt-1 text-end">
//         From Date cannot be later than To Date
//       </div>
//     )}
//   </div>

  
//         <div className="card-body">
//           {/* TOOLBAR */}
//           <div className="row mb-3 align-items-center">
//             <div className="col-md-3">
//               <div className="input-group input-group-sm">
//                 <span className="input-group-text"><i className="fas fa-table"></i></span>
//                 <select className="form-select" value={itemsPerPage} onChange={e => {
//                   const v = e.target.value === "All" ? getFilteredData().length : Number(e.target.value);
//                   setItemsPerPage(v); setCurrentPage(1);
//                 }}>
//                   <option value="All">Show All</option>
//                   {[5, 10, 20, 50, 100, 200, 500, 1000].map(n => <option key={n} value={n}>Show {n}</option>)}
//                 </select>
//               </div>
//             </div>
//                  <div className="col-md-2"></div>

//             <div className="col-md-4">
//               <div className="d-flex flex-wrap gap-2">
//                 <button className="btn btn-success btn-sm d-flex align-items-center gap-1" onClick={downloadPDF}><FileText size={16} /> PDF</button>
//                 <button className="btn btn-success btn-sm d-flex align-items-center gap-1" onClick={downloadExcel}><FileSpreadsheet size={16} /> Excel</button>
//                 <button className="btn btn-success btn-sm d-flex align-items-center gap-1" onClick={downloadCSV}><Download size={16} /> CSV</button>
//                 <button className="btn btn-success btn-sm d-flex align-items-center gap-1" onClick={handlePrint}><Printer size={16} /> Print</button>
//               </div>
//             </div>

//             <div className="col-md-3">
//               <div className="position-relative">
//                 <input type="text" className="form-control form-control-sm pe-5" placeholder="Search..." value={searchTerm}
//                   onChange={e => { setSearchTerm(e.target.value); setCurrentPage(1); }} />
//                 <Search size={16} className="position-absolute text-muted" style={{ right: "10px", top: "50%", transform: "translateY(-50%)" }} />
//               </div>
//             </div>
//           </div>

//           {isLoading ? (
//             <div className="text-center"><div className="spinner-border text-success"></div></div>
//           ) : (
//             <>
//               {renderTable()}
//               {renderPagination()}
//             </>
//           )}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default ReportPharmacy;


// import React, { useEffect, useState } from "react";
// import {
//   Search,
//   Download,
//   Printer,
//   FileSpreadsheet,
//   FileText,
// } from "lucide-react";
// import { FaCheckCircle } from "react-icons/fa";
// import jsPDF from "jspdf";
// import autoTable from "jspdf-autotable";
// import axios from "axios";
// import Apiurl from "./../../environment/Apiurl";

// const ReportPharmacy = () => {
//   /* ----------------------- STATE ----------------------- */
//   const [activeTab, setActiveTab] = useState("medicineMaster");
//   const [searchTerm, setSearchTerm] = useState("");
//   const [currentPage, setCurrentPage] = useState(1);
//   const [itemsPerPage, setItemsPerPage] = useState(5);
//   const [fromDate, setFromDate] = useState("");
//   const [toDate, setToDate] = useState("");
//   const [paymentMode, setPaymentMode] = useState("");
//   const [category, setCategory] = useState("");
//   const [isLoading, setIsLoading] = useState(false);

//   const [medicineMasterData, setMedicineMasterData] = useState([]);
//   const [purchaseOrderData, setPurchaseOrderData] = useState([]);
//   const [purchaseListData, setPurchaseListData] = useState([]);
//   const [salePharmacyData, setSalesPharmacyData] = useState([]);
//   const [salelist, setSaleslist] = useState([]);
//   const [stockPharmacyData, setStockPharmacyData] = useState([]);

//   /* --------------------- FETCH --------------------- */
//   const fetchMedicineMasterData = async () => {
//     setIsLoading(true);
//     try {
//       const { data } = await axios.get(`${Apiurl}/medicine_master`);
//       setMedicineMasterData(data || []);
//     } catch (e) {
//       console.error(e);
//       setMedicineMasterData([]);
//     } finally {
//       setIsLoading(false);
//     }
//   };
//   const fetchPurchaseOrderData = async () => {
//     setIsLoading(true);
//     try {
//       const { data } = await axios.get(`${Apiurl}/purchase_order`);
//       setPurchaseOrderData(data || []);
//     } catch (e) {
//       console.error(e);
//       setPurchaseOrderData([]);
//     } finally {
//       setIsLoading(false);
//     }
//   };
//   const fetchPurchaseListData = async () => {
//     setIsLoading(true);
//     try {
//       const { data } = await axios.get(`${Apiurl}/purchase_pharmacy_list`);
//       setPurchaseListData(data || []);
//     } catch (e) {
//       console.error(e);
//       setPurchaseListData([]);
//     } finally {
//       setIsLoading(false);
//     }
//   };
//   const fetchSalePharmacyData = async () => {
//     setIsLoading(true);
//     try {
//       const { data } = await axios.get(`${Apiurl}/sale`);
//       setSalesPharmacyData(data || []);
//     } catch (e) {
//       console.error(e);
//       setSalesPharmacyData([]);
//     } finally {
//       setIsLoading(false);
//     }
//   };
//   const fetchSalelist = async () => {
//     setIsLoading(true);
//     try {
//       const { data } = await axios.get(`${Apiurl}/sale_list_data`);
//       setSaleslist(data || []);
//     } catch (e) {
//       console.error(e);
//       setSaleslist([]);
//     } finally {
//       setIsLoading(false);
//     }
//   };
//   const fetchStockPharmacyData = async () => {
//     setIsLoading(true);
//     try {
//       const { data } = await axios.get(`${Apiurl}/stock_pharmacy`);
//       setStockPharmacyData(data || []);
//     } catch (e) {
//       console.error(e);
//       setStockPharmacyData([]);
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   useEffect(() => {
//     window.scrollTo({ top: 0, behavior: "smooth" });
//   }, []);

//   useEffect(() => {
//     fetchMedicineMasterData();
//     fetchPurchaseOrderData();
//     fetchPurchaseListData();
//     fetchSalePharmacyData();
//     fetchSalelist();
//     fetchStockPharmacyData();
//   }, []);

//   /* --------------------- TAB CONFIG --------------------- */
//   const tabConfig = {
//     medicineMaster: {
//       title: "Medicine Master",
//       headers: ["S.No", "Medicine", "Category", "Medicine Type", "Manufacturer", "HSN Code"],
//       fields: ["medicine_name", "category", "medicine_type", "manufacturer", "hsn_code"],
//       data: medicineMasterData,
//     },
//     purchaseOrder: {
//       title: "Purchase Order",
//       headers: ["S.No", "Date", "Pur Order No", "Supplier Name", "Order Status"],
//       fields: ["date", "purchase_order_no", "supplier_details[0].supplier_name", "order_status"],
//       data: purchaseOrderData,
//     },
//     purchasePharmacy: {
//       title: "Purchase Product List",
//       headers: [
//         "S.No", "Purchase Date", "Invoice No", "Supplier ID", "Supplier",
//         "Medicine", "Category", "HSN", "Batch No", "Unit Pack",
//         "Pur Price", "Qty", "Taxable", "Discount", "Tax(%)",
//         "CGST", "SGST", "Tax Value", "Amount (₹)",
//       ],
//       fields: [
//         "purchase_date", "invoice_number", "supplier_id", "supplier_name",
//         "medicine_name", "category", "hsn_code", "batch_no", "unit_pack",
//         "purchase_price", "quantity", "", "discount_per_tablet", "gst_percentage",
//         "", "", "tax", "total",
//       ],
//       data: purchaseListData,
//     },
//     salePharmacy: {
//       title: "Sale Pharmacy",
//       headers: [
//         "S.No", "Sale Date", "Invoice No", "Patient ID", "Patient Name",
//         "Category", "Pur Price", "MRP", "Qty", "Net Total",
//         "Paid (Breakdown)", "PayType", "Profit",
//       ],
//       fields: [
//         "sale_date", "invoice_number", "patient_id",
//         "patient_details[0].first_name", "patient_details[0].patient_type",
//         "sales_list[0].purchase_price_per_unit", "sales_list[0].mrp",
//         "sales_list[0].quantity", "net_total", "paid",
//         "sales_pharmacy_payment[0].pay_type", "profit",
//       ],
//       data: salePharmacyData,
//     },
//     salelist: {
//       title: "Sales Product List",
//       headers: [
//         "S.No", "Sale Date", "Invoice No", "Patient ID", "Patient Name",
//         "Medicine Name", "HSN Code", "Category", "MRP", "Qty",
//         "Tax(%)", "CGST", "SGST", "Tax Value", "Total",
//       ],
//       fields: [
//         "sale_date", "invoice_number", "patient_id", "patient_name",
//         "medicine_name", "hsn_code", "category", "mrp", "qty",
//         "tax", "cgst", "sgst", "tax_row_value", "total",
//       ],
//       data: salelist,
//     },
//     stockManagement: {
//       title: "Stock Management",
//       headers: [
//         "S.No", "Medicine", "Category", "Batch No", "Exp Date",
//         "InQty", "OutQty", "Balance", "Pur Price", "MRP", "Profit",
//       ],
//       fields: [
//         "medicine_details.medicine_name", "medicine_details.category",
//         "batch_no", "expiry_date", "inward_quantity", "outward_quantity",
//         "balance_quantity", "purchase_price", "mrp", "profit",
//       ],
//       data: stockPharmacyData,
//     },
//   };

//   /* --------------------- NESTED VALUE --------------------- */
//   const getNestedValue = (obj, path) => {
//     if (!obj) return "N/A";

//     // ---- PROFIT (salePharmacy) ----
//     if (path === "profit" && activeTab === "salePharmacy") {
//       if (!obj.sales_list || !Array.isArray(obj.sales_list)) return "0.00";
//       return obj.sales_list
//         .reduce((s, i) => s + (parseFloat(i.profit) || 0), 0)
//         .toFixed(2);
//     }

//     // ---- PAYTYPE (multiple) ----
//     if (path === "sales_pharmacy_payment[0].pay_type") {
//       const payments = Array.isArray(obj.sales_pharmacy_payment) ? obj.sales_pharmacy_payment : [];
//       if (paymentMode) return payments.some(p => p.pay_type === paymentMode) ? paymentMode : "N/A";
//       return payments.map(p => p.pay_type).join(", ") || "N/A";
//     }

//     // ---- PAID (breakdown) ----
//     if (path === "paid" && activeTab === "salePharmacy") {
//       const payments = Array.isArray(obj.sales_pharmacy_payment) ? obj.sales_pharmacy_payment : [];
//       if (paymentMode) {
//         const amt = payments
//           .filter(p => p.pay_type === paymentMode)
//           .reduce((s, p) => s + (parseFloat(p.paid_amount) || 0), 0);
//         return amt > 0 ? `${paymentMode}: ${amt.toFixed(2)}` : "0.00";
//       }
//       return payments
//         .map(p => `${p.pay_type}: ${parseFloat(p.paid_amount || 0).toFixed(2)}`)
//         .join(", ") || "0.00";
//     }

//     // ---- STOCK PROFIT ----
//     if (activeTab === "stockManagement" && path === "profit") {
//       const { profit } = calculateStockValues(obj);
//       return profit;
//     }

//     // ---- NUMERIC FORMATTING (salelist, purchasePharmacy) ----
//     if (
//       ["salelist", "purchasePharmacy"].includes(activeTab) &&
//       ["mrp", "qty", "tax", "cgst", "sgst", "tax_row_value", "total"].includes(path)
//     ) {
//       const v = parseFloat(obj[path]);
//       return isNaN(v) ? "0.00" : v.toFixed(2);
//     }

//     // ---- GENERAL NESTED ----
//     const parts = path.match(/(\w+|\[\d+\])/g) || [path];
//     let cur = obj;
//     for (const part of parts) {
//       if (part.startsWith("[") && part.endsWith("]")) {
//         const idx = parseInt(part.slice(1, -1));
//         cur = cur ? cur[idx] : undefined;
//       } else {
//         cur = cur ? cur[part] : undefined;
//       }
//       if (!cur) break;
//     }

//     if (["sub_total", "net_total", "discount_value", "paid", "purchase_price", "mrp"].includes(path.split(".").pop())) {
//       const v = parseFloat(cur);
//       return isNaN(v) ? "0.00" : v.toFixed(2);
//     }
//     return cur ?? "N/A";
//   };

//   /* --------------------- STOCK CALC --------------------- */
//   const calculateStockValues = (item) => {
//     const purchasePrice = parseFloat(item.purchase_price) || 0;
//     const mrp = parseFloat(item.mrp) || 0;
//     let tabletsPerPack = 1;
//     if (typeof item.unit_pack === "string" && item.unit_pack.includes("*")) {
//       const parts = item.unit_pack.split("*").map(p => parseInt(p.trim()));
//       if (parts.length === 2 && !isNaN(parts[1])) tabletsPerPack = parts[1];
//     }
//     const perTabletPrice = tabletsPerPack > 0 ? purchasePrice / tabletsPerPack : 0;
//     const perTabletMrp = tabletsPerPack > 0 ? mrp / tabletsPerPack : 0;
//     const profit = parseFloat(item.profit) || 0;
//     return {
//       perTabletPrice: perTabletPrice.toFixed(2),
//       perTabletMrp: perTabletMrp.toFixed(2),
//       profit: profit.toFixed(2),
//     };
//   };

//   /* --------------------- FILTERING --------------------- */
//   const getCurrentData = () => {
//     const cfg = tabConfig[activeTab];
//     if (!cfg) return [];

//     let filtered = cfg.data || [];

//     /* ---------- CATEGORY FILTER ---------- */
//     if (category) {
//       if (["medicineMaster", "stockManagement", "salelist"].includes(activeTab)) {
//         filtered = filtered.filter(item => {
//           if (activeTab === "medicineMaster") return item.category === category;
//           if (activeTab === "stockManagement") return item.medicine_details?.category === category;
//           if (activeTab === "salelist") return item.category === category;   // <-- NEW
//           return true;
//         });
//       }
//       // salePharmacy uses patient_type as category
//       if (activeTab === "salePharmacy") {
//         filtered = filtered.filter(item => item.patient_details?.[0]?.patient_type === category);
//       }
//     }

//     /* ---------- DATE FILTER ---------- */
//     if (["salePharmacy", "salelist", "purchaseOrder", "purchasePharmacy"].includes(activeTab) && (fromDate || toDate)) {
//       filtered = filtered.filter(item => {
//         const key = item.sale_date || item.purchase_date || item.date;
//         const d = new Date(key);
//         if (isNaN(d)) return false;
//         let ok = true;
//         if (fromDate) {
//           const f = new Date(fromDate); f.setHours(0, 0, 0, 0);
//           const dd = new Date(d); dd.setHours(0, 0, 0, 0);
//           ok = ok && dd >= f;
//         }
//         if (toDate && ok) {
//           const t = new Date(toDate); t.setHours(23, 59, 59, 999);
//           const dd = new Date(d); dd.setHours(23, 59, 59, 999);
//           ok = ok && dd <= t;
//         }
//         return ok;
//       });
//     }

//     /* ---------- PAYMENT MODE FILTER ---------- */
//     if (activeTab === "salePharmacy" && paymentMode) {
//       filtered = filtered.filter(item =>
//         Array.isArray(item.sales_pharmacy_payment) &&
//         item.sales_pharmacy_payment.some(p => p.pay_type === paymentMode)
//       );
//     }

//     /* ---------- BUILD ROWS ---------- */
//     return filtered.map((item, idx) => {
//       const row = { sNo: idx + 1 };
//       cfg.fields.forEach(f => (row[f] = getNestedValue(item, f)));
//       return row;
//     });
//   };

//   const getFilteredData = () => {
//     const data = getCurrentData();
//     if (!searchTerm) return data;
//     return data.filter(item =>
//       Object.values(item).some(v => v?.toString().toLowerCase().includes(searchTerm.toLowerCase()))
//     );
//   };

//   const getPaginatedData = () => {
//     const data = getFilteredData();
//     const start = (currentPage - 1) * itemsPerPage;
//     return data.slice(start, start + itemsPerPage);
//   };
//   const getTotalPages = () => Math.ceil(getFilteredData().length / itemsPerPage);

//   /* --------------------- TOTALS --------------------- */
//   const getSalePharmacyTotals = () => {
//     if (activeTab !== "salePharmacy") return { netTotal: 0, paid: 0, profit: 0 };
//     const data = getFilteredData();
//     return data.reduce(
//       (acc, item) => {
//         const net = parseFloat(item.net_total) || 0;
//         const prof = parseFloat(item.profit) || 0;
//         let paid = 0;
//         const orig = salePharmacyData.find(
//           o => o.sale_date === item.sale_date && o.invoice_number === item.invoice_number
//         );
//         if (orig?.sales_pharmacy_payment) {
//           const pays = orig.sales_pharmacy_payment;
//           if (paymentMode) {
//             paid = pays
//               .filter(p => p.pay_type === paymentMode)
//               .reduce((s, p) => s + (parseFloat(p.paid_amount) || 0), 0);
//           } else {
//             paid = pays.reduce((s, p) => s + (parseFloat(p.paid_amount) || 0), 0);
//           }
//         }
//         return { netTotal: acc.netTotal + net, paid: acc.paid + paid, profit: acc.profit + prof };
//       },
//       { netTotal: 0, paid: 0, profit: 0 }
//     );
//   };

//   const getSaleListTotals = () => {
//     if (activeTab !== "salelist") return { mrp: 0, qty: 0, tax: 0, cgst: 0, sgst: 0, tax_row_value: 0, total: 0 };
//     const data = getFilteredData();
//     return data.reduce(
//       (acc, i) => ({
//         mrp: acc.mrp + (parseFloat(i.mrp) || 0),
//         qty: acc.qty + (parseFloat(i.qty) || 0),
//         tax: acc.tax + (parseFloat(i.tax) || 0),
//         cgst: acc.cgst + (parseFloat(i.cgst) || 0),
//         sgst: acc.sgst + (parseFloat(i.sgst) || 0),
//         tax_row_value: acc.tax_row_value + (parseFloat(i.tax_row_value) || 0),
//         total: acc.total + (parseFloat(i.total) || 0),
//       }),
//       { mrp: 0, qty: 0, tax: 0, cgst: 0, sgst: 0, tax_row_value: 0, total: 0 }
//     );
//   };

//   const getStockManagementTotals = () => {
//     if (activeTab !== "stockManagement") return { totalPurchasePrice: 0, totalMrp: 0, totalProfit: 0 };
//     const data = getFilteredData();
//     return data.reduce(
//       (acc, i) => ({
//         totalPurchasePrice: acc.totalPurchasePrice + (parseFloat(i.purchase_price) || 0),
//         totalMrp: acc.totalMrp + (parseFloat(i.mrp) || 0),
//         totalProfit: acc.totalProfit + (parseFloat(i.profit) || 0),
//       }),
//       { totalPurchasePrice: 0, totalMrp: 0, totalProfit: 0 }
//     );
//   };

//   const getPurchasePharmacyTotals = () => {
//     if (activeTab !== "purchasePharmacy") return { quantity: 0, tax: 0, mrp: 0, total: 0 };
//     const data = getFilteredData();
//     return data.reduce(
//       (acc, i) => ({
//         quantity: acc.quantity + (parseInt(i.quantity) || 0),
//         tax: acc.tax + (parseFloat(i.tax) || 0),
//         mrp: acc.mrp + (parseFloat(i.mrp) || 0),
//         total: acc.total + (parseFloat(i.total) || 0),
//       }),
//       { quantity: 0, tax: 0, mrp: 0, total: 0 }
//     );
//   };

//   /* --------------------- EXPORT HELPERS --------------------- */
//   const buildExportRow = (item, fields, cfg) => {
//     const row = {};
//     fields.forEach(f => {
//       if (f === "paid" && activeTab === "salePharmacy") {
//         const payments = Array.isArray(item.sales_pharmacy_payment) ? item.sales_pharmacy_payment : [];
//         if (paymentMode) {
//           const amt = payments
//             .filter(p => p.pay_type === paymentMode)
//             .reduce((s, p) => s + (parseFloat(p.paid_amount) || 0), 0);
//           row[f] = amt > 0 ? `${paymentMode}: ${amt.toFixed(2)}` : "0.00";
//         } else {
//           row[f] = payments
//             .map(p => `${p.pay_type}: ${parseFloat(p.paid_amount || 0).toFixed(2)}`)
//             .join(", ") || "0.00";
//         }
//       } else {
//         row[f] = getNestedValue(item, f);
//       }
//     });
//     return row;
//   };

//   /* --------------------- EXPORTS --------------------- */
//   const downloadCSV = () => {
//     const data = getFilteredData();
//     const cfg = tabConfig[activeTab];
//     const fields = ["sNo", ...cfg.fields];
//     let csv = cfg.headers.join(",") + "\n";

//     data.forEach(item => {
//       const row = buildExportRow(item, cfg.fields, cfg);
//       const line = fields.map(f => `"${row[f] || ""}"`).join(",");
//       csv += line + "\n";
//     });

//     if (activeTab === "salePharmacy") {
//       const t = getSalePharmacyTotals();
//       const totalLine = [
//         "", "", "", "", "", "", "", "", "",
//         t.netTotal.toFixed(2),
//         paymentMode ? `${paymentMode}: ${t.paid.toFixed(2)}` : `Total: ${t.paid.toFixed(2)}`,
//         "", t.profit.toFixed(2)
//       ];
//       csv += totalLine.join(",") + "\n";
//     }

//     const blob = new Blob([csv], { type: "text/csv" });
//     const url = URL.createObjectURL(blob);
//     const a = document.createElement("a");
//     a.href = url;
//     a.download = `${activeTab}_report.csv`;
//     a.click();
//     URL.revokeObjectURL(url);
//   };

//   const downloadExcel = () => {
//     const data = getFilteredData();
//     const cfg = tabConfig[activeTab];
//     const fields = ["sNo", ...cfg.fields];
//     let html = `<table border="1"><tr>${cfg.headers.map(h => `<th>${h}</th>`).join("")}</tr>`;

//     data.forEach(item => {
//       const row = buildExportRow(item, cfg.fields, cfg);
//       html += `<tr>${fields.map(f => `<td>${row[f] || ""}</td>`).join("")}</tr>`;
//     });

//     if (activeTab === "salePharmacy") {
//       const t = getSalePharmacyTotals();
//       html += `<tr>${[
//         "", "", "", "", "", "", "", "", "",
//         t.netTotal.toFixed(2),
//         paymentMode ? `${paymentMode}: ${t.paid.toFixed(2)}` : `Total: ${t.paid.toFixed(2)}`,
//         "", t.profit.toFixed(2)
//       ].map(v => `<td>${v}</td>`).join("")}</tr>`;
//     }

//     html += `</table>`;
//     const blob = new Blob([html], { type: "application/vnd.ms-excel" });
//     const url = URL.createObjectURL(blob);
//     const a = document.createElement("a");
//     a.href = url;
//     a.download = `${activeTab}_report.xls`;
//     a.click();
//     URL.revokeObjectURL(url);
//   };

//   const downloadPDF = () => {
//     const data = getFilteredData();
//     const cfg = tabConfig[activeTab];
//     const fields = ["sNo", ...cfg.fields];
//     const doc = new jsPDF();

//     doc.setFontSize(18);
//     doc.text(`${cfg.title} Report`, 14, 20);
//     doc.setFontSize(12);
//     doc.text(`Generated on: ${new Date().toLocaleDateString()}`, 14, 30);

//     const body = data.map(item => {
//       const row = buildExportRow(item, cfg.fields, cfg);
//       return fields.map(f => row[f] || "");
//     });

//     if (activeTab === "salePharmacy") {
//       const t = getSalePharmacyTotals();
//       body.push([
//         "", "", "", "", "", "", "", "", "",
//         t.netTotal.toFixed(2),
//         paymentMode ? `${paymentMode}: ${t.paid.toFixed(2)}` : `Total: ${t.paid.toFixed(2)}`,
//         "", t.profit.toFixed(2)
//       ]);
//     }

//     autoTable(doc, {
//       startY: 40,
//       head: [cfg.headers],
//       body,
//       theme: "striped",
//       headStyles: { fillColor: [46, 146, 144], textColor: [255, 255, 255] },
//     });
//     doc.save(`${activeTab}_report.pdf`);
//   };

//   const handlePrint = () => {
//     const data = getFilteredData();
//     const cfg = tabConfig[activeTab];
//     const fields = ["sNo", ...cfg.fields];

//     const printWin = window.open("", "_blank");
//     let html = `
//       <html><head><title>${cfg.title} Report</title>
//       <style>
//         body{font-family:Arial;margin:20px;}
//         h1{color:#01AEBE;text-align:center;}
//         table{width:100%;border-collapse:collapse;margin-top:20px;}
//         th,td{border:1px solid #ddd;padding:8px;text-align:left;}
//         th{background:#01AEBE;color:white;}
//         tr:nth-child(even){background:#f2f2f2;}
//       </style>
//       </head><body>
//       <h1>${cfg.title} Report</h1>
//       <p>Generated on: ${new Date().toLocaleDateString()}</p>
//       <table><thead><tr>${cfg.headers.map(h => `<th>${h}</th>`).join("")}</tr></thead><tbody>
//     `;

//     data.forEach(item => {
//       const row = buildExportRow(item, cfg.fields, cfg);
//       html += `<tr>${fields.map(f => `<td>${row[f] || ""}</td>`).join("")}</tr>`;
//     });

//     if (activeTab === "salePharmacy") {
//       const t = getSalePharmacyTotals();
//       html += `<tr>${[
//         "", "", "", "", "", "", "", "", "",
//         t.netTotal.toFixed(2),
//         paymentMode ? `${paymentMode}: ${t.paid.toFixed(2)}` : `Total: ${t.paid.toFixed(2)}`,
//         "", t.profit.toFixed(2)
//       ].map(v => `<td><strong>${v}</strong></td>`).join("")}</tr>`;
//     }

//     html += `</tbody></table></body></html>`;
//     printWin.document.write(html);
//     printWin.document.close();
//     setTimeout(() => {
//       printWin.print();
//       printWin.close();
//     }, 250);
//   };

//   /* --------------------- RENDER TABLE --------------------- */
//   const renderTable = () => {
//     const data = getPaginatedData();
//     const cfg = tabConfig[activeTab];
//     const fields = ["sNo", ...cfg.fields];

//     return (
//       <div className="table-responsive">
//         <table className="table table-bordered">
//           <thead>
//             <tr style={{ backgroundColor: "#01AEBE", color: "white" }}>
//               {cfg.headers.map((h, i) => (
//                 <th key={i}>{h}</th>
//               ))}
//             </tr>
//           </thead>
//           <tbody>
//             {data.map((item, idx) => (
//               <tr key={idx}>
//                 {fields.map((f, i) => (
//                   <td key={i}>
//                     {f === "order_status" ? (
//                       <span className={`badge rounded-pill ${getStatusBadgeClass(item[f])}`}>
//                         <FaCheckCircle /> {item[f]}
//                       </span>
//                     ) : (
//                       item[f]
//                     )}
//                   </td>
//                 ))}
//               </tr>
//             ))}

//             {/* ----- TOTALS ----- */}
//             {activeTab === "salePharmacy" && (
//               <tr style={{ backgroundColor: "#f2f2f2", fontWeight: "bold" }}>
//                 <td colSpan={9}>Totals</td>
//                 <td>{getSalePharmacyTotals().netTotal.toFixed(2)}</td>
//                 <td>
//                   {paymentMode
//                     ? `${paymentMode}: ${getSalePharmacyTotals().paid.toFixed(2)}`
//                     : `Total: ${getSalePharmacyTotals().paid.toFixed(2)}`}
//                 </td>
//                 <td></td>
//                 <td>{getSalePharmacyTotals().profit.toFixed(2)}</td>
//               </tr>
//             )}
//           </tbody>
//         </table>
//       </div>
//     );
//   };

//   const getStatusBadgeClass = status => {
//     const map = {
//       Active: "bg-success",
//       Available: "bg-success",
//       Paid: "bg-success",
//       Completed: "bg-success",
//       Pending: "bg-warning",
//       "Low Stock": "bg-warning",
//       "Out of Stock": "bg-danger",
//     };
//     return map[status] || "bg-success";
//   };

//   /* --------------------- PAGINATION --------------------- */
//   const renderPagination = () => {
//     const total = getTotalPages();
//     if (total <= 1) return null;
//     const max = 5;
//     let start = Math.max(1, currentPage - Math.floor(max / 2));
//     let end = Math.min(total, start + max - 1);
//     if (end - start + 1 < max) start = Math.max(1, end - max + 1);
//     const pages = [];
//     for (let i = start; i <= end; i++) pages.push(i);

//     return (
//       <div className="d-flex justify-content-between align-items-center mt-3">
//         <div className="text-muted">
//           Showing {(currentPage - 1) * itemsPerPage + 1} to{" "}
//           {Math.min(currentPage * itemsPerPage, getFilteredData().length)} of{" "}
//           {getFilteredData().length} entries
//         </div>
//         <div className="d-flex gap-2">
//           <button
//             className="btn btn-outline-secondary btn-sm"
//             onClick={() => setCurrentPage(Math.max(1, currentPage - 1))}
//             disabled={currentPage === 1}
//           >
//             Previous
//           </button>
//           {pages.map(p => (
//             <button
//               key={p}
//               className={`btn btn-sm ${currentPage === p ? "btn-success" : "btn-outline-secondary"}`}
//               onClick={() => setCurrentPage(p)}
//             >
//               {p}
//             </button>
//           ))}
//           <button
//             className="btn btn-outline-secondary btn-sm"
//             onClick={() => setCurrentPage(Math.min(total, currentPage + 1))}
//             disabled={currentPage === total}
//           >
//             Next
//           </button>
//         </div>
//       </div>
//     );
//   };

//   /* --------------------- TAB CHANGE --------------------- */
//   const handleTabChange = key => {
//     setActiveTab(key);
//     setCurrentPage(1);
//     setSearchTerm("");
//     setFromDate("");
//     setToDate("");
//     setPaymentMode("");
//     setCategory("");
//   };

//   /* --------------------- JSX --------------------- */
//   return (
//     <div className="container-fluid p-4" style={{ backgroundColor: "#f8f9fa", minHeight: "100vh" }}>
//       {/* TABS */}
//       <div className="mb-4">
//         <ul className="nav nav-tabs flex-wrap">
//           {Object.entries(tabConfig).map(([k, c]) => (
//             <li key={k} className="nav-item">
//               <button
//                 className={`nav-link ${activeTab === k ? "active" : ""} px-3 py-2`}
//                 style={{
//                   backgroundColor: activeTab === k ? "#01AEBE" : "transparent",
//                   color: activeTab === k ? "white" : "#01AEBE",
//                   border: "1px solid #01AEBE",
//                   borderRadius: "0",
//                   fontSize: "14px",
//                 }}
//                 onClick={() => handleTabChange(k)}
//               >
//                 {c.title}
//               </button>
//             </li>
//           ))}
//         </ul>
//       </div>

//       <div className="card shadow-sm border-0">
//         <div className="card-header" style={{ backgroundColor: "#01AEBE", color: "white" }}>
//           <div className="row d-flex justify-content-between align-items-center">
//             <div className="col-lg-5 col-md-5 d-flex align-items-center">
//               <h5 className="mb-0 fw-bold">{tabConfig[activeTab]?.title}</h5>
//             </div>

//             <div className="col-lg-7 col-md-7 d-flex justify-content-center align-items-start gap-2 flex-wrap">
//               {/* DATE FILTERS */}
//               {["salePharmacy", "purchaseOrder", "purchasePharmacy", "salelist"].includes(activeTab) && (
//                 <>
//                   <div>
//                     <label className="form-label small mb-1 text-white">From Date:</label>
//                     <input
//                       type="date"
//                       className="form-control form-control-sm"
//                       value={fromDate}
//                       onChange={e => {
//                         setFromDate(e.target.value);
//                         setCurrentPage(1);
//                       }}
//                       max={toDate || undefined}
//                     />
//                   </div>

//                   <div>
//                     <label className="form-label small mb-1 text-white">To Date:</label>
//                     <input
//                       type="date"
//                       className="form-control form-control-sm"
//                       value={toDate}
//                       onChange={e => {
//                         setToDate(e.target.value);
//                         setCurrentPage(1);
//                       }}
//                       min={fromDate || undefined}
//                     />
//                   </div>

//                   {(fromDate || toDate) && (
//                     <div>
//                       <label className="form-label small mb-1 text-white">&nbsp;</label>
//                       <button
//                         className="btn btn-outline-light btn-sm w-100"
//                         onClick={() => {
//                           setFromDate("");
//                           setToDate("");
//                           setCurrentPage(1);
//                         }}
//                       >
//                         Clear Dates
//                       </button>
//                     </div>
//                   )}
//                 </>
//               )}

//               {/* PAYMENT MODE */}
//               {activeTab === "salePharmacy" && (
//                 <div>
//                   <label className="form-label small mb-1 text-white">Paytype:</label>
//                   <select
//                     className="form-select form-select-sm"
//                     value={paymentMode}
//                     onChange={e => {
//                       setPaymentMode(e.target.value);
//                       setCurrentPage(1);
//                     }}
//                   >
//                     <option value="">All</option>
//                     {["Cash", "Card", "Gpay", "Phonepe", "Paytm", "Amazon Pay", "UPI"].map(p => (
//                       <option key={p} value={p}>{p}</option>
//                     ))}
//                   </select>
//                 </div>
//               )}

//               {/* CATEGORY FILTERS */}
//               {(activeTab === "medicineMaster" || activeTab === "stockManagement" || activeTab === "salePharmacy" ) && (
//                 <div>
//                   <label className="form-label small mb-1 text-white">Category:</label>
//                   <select
//                     className="form-select form-select-sm"
//                     value={category}
//                     onChange={e => {
//                       setCategory(e.target.value);
//                       setCurrentPage(1);
//                     }}
//                   >
//                     <option value="">All</option>
//                     <option value="Homeopathy">Homeopathy</option>
//                     <option value="Yoga">Yoga</option>
//                   </select>
//                 </div>
//               )}

//               {/* SALELIST CATEGORY FILTER */}
//               {activeTab === "salelist" && (
//                 <div>
//                   <label className="form-label small mb-1 text-white">Category:</label>
//                   <select
//                     className="form-select form-select-sm"
//                     value={category}
//                     onChange={e => {
//                       setCategory(e.target.value);
//                       setCurrentPage(1);
//                     }}
//                   >
//                     <option value="">All</option>
//                     {[
//                       "Tablet","Capsule","Syrup","Injection","Powder","Sachet","Cream","Ointment",
//                       "Gel","Drops","Inhaler","Suppository","Suspension","Spray","Lotion",
//                       "Solution","Patch","Dispersible Tablet","Chewable Tablet","IV Fluid"
//                     ].map(c => (
//                       <option key={c} value={c}>{c}</option>
//                     ))}
//                   </select>
//                 </div>
//               )}
//             </div>
//           </div>

//           {fromDate && toDate && new Date(fromDate) > new Date(toDate) && (
//             <div className="text-danger small mt-1 text-end">
//               From Date cannot be later than To Date
//             </div>
//           )}
//         </div>

//         <div className="card-body">
//           {/* TOOLBAR */}
//           <div className="row mb-3 align-items-center">
//             <div className="col-md-3">
//               <div className="input-group input-group-sm">
//                 <span className="input-group-text"><i className="fas fa-table"></i></span>
//                 <select
//                   className="form-select"
//                   value={itemsPerPage}
//                   onChange={e => {
//                     const v = e.target.value === "All" ? getFilteredData().length : Number(e.target.value);
//                     setItemsPerPage(v);
//                     setCurrentPage(1);
//                   }}
//                 >
//                   <option value="All">Show All</option>
//                   {[5, 10, 20, 50, 100, 200, 500, 1000].map(n => (
//                     <option key={n} value={n}>Show {n}</option>
//                   ))}
//                 </select>
//               </div>
//             </div>

//             <div className="col-md-2"></div>

//             <div className="col-md-4">
//               <div className="d-flex flex-wrap gap-2">
//                 <button className="btn btn-success btn-sm d-flex align-items-center gap-1" onClick={downloadPDF}>
//                   <FileText size={16} /> PDF
//                 </button>
//                 <button className="btn btn-success btn-sm d-flex align-items-center gap-1" onClick={downloadExcel}>
//                   <FileSpreadsheet size={16} /> Excel
//                 </button>
//                 <button className="btn btn-success btn-sm d-flex align-items-center gap-1" onClick={downloadCSV}>
//                   <Download size={16} /> CSV
//                 </button>
//                 <button className="btn btn-success btn-sm d-flex align-items-center gap-1" onClick={handlePrint}>
//                   <Printer size={16} /> Print
//                 </button>
//               </div>
//             </div>

//             <div className="col-md-3">
//               <div className="position-relative">
//                 <input
//                   type="text"
//                   className="form-control form-control-sm pe-5"
//                   placeholder="Search..."
//                   value={searchTerm}
//                   onChange={e => {
//                     setSearchTerm(e.target.value);
//                     setCurrentPage(1);
//                   }}
//                 />
//                 <Search size={16} className="position-absolute text-muted" style={{ right: "10px", top: "50%", transform: "translateY(-50%)" }} />
//               </div>
//             </div>
//           </div>

//           {isLoading ? (
//             <div className="text-center">
//               <div className="spinner-border text-success"></div>
//             </div>
//           ) : (
//             <>
//               {renderTable()}
//               {renderPagination()}
//             </>
//           )}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default ReportPharmacy;



// import React, { useEffect, useState } from "react";
// import {
//   Search,
//   Download,
//   Printer,
//   FileSpreadsheet,
//   FileText,
// } from "lucide-react";
// import { FaCheckCircle } from "react-icons/fa";
// import jsPDF from "jspdf";
// import autoTable from "jspdf-autotable";
// import axios from "axios";
// import Apiurl from "./../../environment/Apiurl";

// const ReportPharmacy = () => {
//   const [activeTab, setActiveTab] = useState("medicineMaster");
//   const [searchTerm, setSearchTerm] = useState("");
//   const [currentPage, setCurrentPage] = useState(1);
//   const [itemsPerPage, setItemsPerPage] = useState(5);
//   const [fromDate, setFromDate] = useState("");
//   const [toDate, setToDate] = useState("");
//   const [paymentMode, setPaymentMode] = useState("");
//   const [category, setCategory] = useState("");
//   const [isLoading, setIsLoading] = useState(false);

//   const [medicineMasterData, setMedicineMasterData] = useState([]);
//   const [purchaseOrderData, setPurchaseOrderData] = useState([]);
//   const [purchaseListData, setPurchaseListData] = useState([]);
//   const [salePharmacyData, setSalesPharmacyData] = useState([]);
//   const [salelist, setSaleslist] = useState([]);
//   const [stockPharmacyData, setStockPharmacyData] = useState([]);

//   // ==================== FETCH FUNCTIONS ====================
//   const fetchMedicineMasterData = async () => {
//     setIsLoading(true);
//     try {
//       const { data } = await axios.get(`${Apiurl}/medicine_master`);
//       setMedicineMasterData(data || []);
//     } catch (e) { console.error(e); setMedicineMasterData([]); } finally { setIsLoading(false); }
//   };
//   const fetchPurchaseOrderData = async () => {
//     setIsLoading(true);
//     try {
//       const { data } = await axios.get(`${Apiurl}/purchase_order`);
//       setPurchaseOrderData(data || []);
//     } catch (e) { console.error(e); setPurchaseOrderData([]); } finally { setIsLoading(false); }
//   };
//   const fetchPurchaseListData = async () => {
//     setIsLoading(true);
//     try {
//       const { data } = await axios.get(`${Apiurl}/purchase_pharmacy_list`);
//       setPurchaseListData(data || []);
//     } catch (e) { console.error(e); setPurchaseListData([]); } finally { setIsLoading(false); }
//   };
//   const fetchSalePharmacyData = async () => {
//     setIsLoading(true);
//     try {
//       const { data } = await axios.get(`${Apiurl}/sale`);
//       setSalesPharmacyData(data || []);
//     } catch (e) { console.error(e); setSalesPharmacyData([]); } finally { setIsLoading(false); }
//   };
//   const fetchSalelist = async () => {
//     setIsLoading(true);
//     try {
//       const { data } = await axios.get(`${Apiurl}/sale_list_data`);
//       setSaleslist(data || []);
//     } catch (e) { console.error(e); setSaleslist([]); } finally { setIsLoading(false); }
//   };
//   const fetchStockPharmacyData = async () => {
//     setIsLoading(true);
//     try {
//       const { data } = await axios.get(`${Apiurl}/stock_pharmacy`);
//       setStockPharmacyData(data || []);
//     } catch (e) { console.error(e); setStockPharmacyData([]); } finally { setIsLoading(false); }
//   };

//   useEffect(() => {
//     window.scrollTo({ top: 0, behavior: "smooth" });
//   }, []);

//   useEffect(() => {
//     fetchMedicineMasterData();
//     fetchPurchaseOrderData();
//     fetchPurchaseListData();
//     fetchSalePharmacyData();
//     fetchSalelist();
//     fetchStockPharmacyData();
//   }, []);

//   // ==================== TAB CONFIG ====================
//   const tabConfig = {
//     medicineMaster: {
//       title: "Medicine Master",
//       headers: ["S.No", "Medicine", "Category", "Medicine Type", "Manufacturer", "HSN Code"],
//       fields: ["medicine_name", "category", "medicine_type", "manufacturer", "hsn_code"],
//       data: medicineMasterData,
//     },
//     purchaseOrder: {
//       title: "Purchase Order",
//       headers: ["S.No", "Date", "Pur Order No", "Supplier Name", "Order Status"],
//       fields: ["date", "purchase_order_no", "supplier_details[0].supplier_name", "order_status"],
//       data: purchaseOrderData,
//     },
//     purchasePharmacy: {
//       title: "Purchase Product List",
//       headers: [
//         "S.No", "Purchase Date", "Invoice No", "Supplier ID", "Supplier",
//         "Medicine", "Category", "HSN", "Batch No", "Unit Pack",
//         "Pur Price", "Qty", "Taxable", "Discount", "Tax(%)",
//         "CGST", "SGST", "Tax Value", "Amount (₹)",
//       ],
//       fields: [
//         "purchase_date", "invoice_number", "supplier_id", "supplier_name",
//         "medicine_name", "category", "hsn_code", "batch_no", "unit_pack",
//         "purchase_price", "quantity", "", "discount_per_tablet", "gst_percentage",
//         "", "", "tax", "total",
//       ],
//       data: purchaseListData,
//     },
//     salePharmacy: {
//       title: "Sale Pharmacy",
//       headers: [
//         "S.No", "Sale Date", "Invoice No", "Patient ID", "Patient Name",
//         "Category", "Pur Price", "MRP", "Qty", "Net Total",
//         "Paid ", "PayType", "Profit",
//       ],
//       fields: [
//         "sale_date", "invoice_number", "patient_id",
//         "patient_details[0].first_name", "patient_details[0].patient_type",
//         "sales_list[0].purchase_price_per_unit", "sales_list[0].mrp",
//         "sales_list[0].quantity", "net_total", "paid",
//         "pay_type", "profit",  // ← pay_type is now per row
//       ],
//       data: salePharmacyData,
//     },
//     salelist: {
//       title: "Sales Product List",
//       headers: [
//         "S.No", "Sale Date", "Invoice No", "Patient ID", "Patient Name",
//         "Medicine Name", "HSN Code", "Category", "MRP", "Qty",
//         "Tax(%)", "CGST", "SGST", "Tax Value", "Total",
//       ],
//       fields: [
//         "sale_date", "invoice_number", "patient_id", "patient_name",
//         "medicine_name", "hsn_code", "category", "mrp", "qty",
//         "tax", "cgst", "sgst", "tax_row_value", "total",
//       ],
//       data: salelist,
//     },
//     stockManagement: {
//       title: "Stock Management",
//       headers: [
//         "S.No", "Medicine", "Category", "Batch No", "Exp Date",
//         "InQty", "OutQty", "Balance", "Pur Price", "MRP", "Profit",
//       ],
//       fields: [
//         "medicine_details.medicine_name", "medicine_details.category",
//         "batch_no", "expiry_date", "inward_quantity", "outward_quantity",
//         "balance_quantity", "purchase_price", "mrp", "profit",
//       ],
//       data: stockPharmacyData,
//     },
//   };

//   // ==================== NESTED VALUE (kept for other tabs) ====================
//   const getNestedValue = (obj, path) => {
//     if (!obj) return "N/A";
//     const parts = path.match(/(\w+|\[\d+\])/g) || [path];
//     let cur = obj;
//     for (const part of parts) {
//       if (part.startsWith("[") && part.endsWith("]")) {
//         const idx = parseInt(part.slice(1, -1));
//         cur = cur ? cur[idx] : undefined;
//       } else {
//         cur = cur ? cur[part] : undefined;
//       }
//       if (!cur) break;
//     }
//     if (["sub_total", "net_total", "discount_value", "paid", "purchase_price", "mrp"].includes(path.split(".").pop())) {
//       const v = parseFloat(cur);
//       return isNaN(v) ? "0.00" : v.toFixed(2);
//     }
//     return cur ?? "N/A";
//   };

//   // ==================== DATA FILTERING & ROW DUPLICATION ====================
//   const getCurrentData = () => {
//     const config = tabConfig[activeTab];
//     if (!config) return [];

//     let filteredData = config.data || [];

//     // Category filter
//     if (category) {
//       if (["medicineMaster", "stockManagement", "salelist"].includes(activeTab)) {
//         filteredData = filteredData.filter(item => {
//           if (activeTab === "medicineMaster") return item.category === category;
//           if (activeTab === "stockManagement") return item.medicine_details?.category === category;
//           if (activeTab === "salelist") return item.category === category;
//           return true;
//         });
//       }
//       if (activeTab === "salePharmacy") {
//         filteredData = filteredData.filter(item =>
//           item.patient_details?.[0]?.patient_type === category
//         );
//       }
//     }

//     // Date filters
//     if (["salePharmacy", "salelist", "purchaseOrder", "purchasePharmacy"].includes(activeTab) && (fromDate || toDate)) {
//       filteredData = filteredData.filter(item => {
//         const itemDate = new Date(item.sale_date || item.purchase_date || item.date);
//         if (isNaN(itemDate)) return false;
//         let ok = true;
//         if (fromDate) {
//           const from = new Date(fromDate); from.setHours(0, 0, 0, 0);
//           const d = new Date(itemDate); d.setHours(0, 0, 0, 0);
//           ok = ok && d >= from;
//         }
//         if (toDate && ok) {
//           const to = new Date(toDate); to.setHours(23, 59, 59, 999);
//           const d = new Date(itemDate); d.setHours(23, 59, 59, 999);
//           ok = ok && d <= to;
//         }
//         return ok;
//       });
//     }

//     // Paytype filter
//     if (activeTab === "salePharmacy" && paymentMode) {
//       filteredData = filteredData.filter(item =>
//         Array.isArray(item.sales_pharmacy_payment) &&
//         item.sales_pharmacy_payment.some(p => p.pay_type === paymentMode)
//       );
//     }

//     // === DUPLICATE ROWS FOR SALE PHARMACY (ONE PER PAYMENT MODE) ===
//     if (activeTab === "salePharmacy") {
//       const duplicated = [];
//       filteredData.forEach((item, idx) => {
//         const payments = Array.isArray(item.sales_pharmacy_payment) ? item.sales_pharmacy_payment : [];
//         const modesToShow = paymentMode ? payments.filter(p => p.pay_type === paymentMode) : payments;

//         if (modesToShow.length === 0) {
//           duplicated.push({
//             sNo: idx + 1,
//             sale_date: item.sale_date,
//             invoice_number: item.invoice_number,
//             patient_id: item.patient_id,
//             "patient_details[0].first_name": item.patient_details?.[0]?.first_name || "N/A",
//             "patient_details[0].patient_type": item.patient_details?.[0]?.patient_type || "N/A",
//             "sales_list[0].purchase_price_per_unit": item.sales_list?.[0]?.purchase_price_per_unit || "0.00",
//             "sales_list[0].mrp": item.sales_list?.[0]?.mrp || "0.00",
//             "sales_list[0].quantity": item.sales_list?.[0]?.quantity || "0",
//             net_total: parseFloat(item.net_total || 0).toFixed(2),
//             paid: "0.00",
//             pay_type: "N/A",
//             profit: item.sales_list?.reduce((s, sl) => s + (parseFloat(sl.profit) || 0), 0).toFixed(2) || "0.00",
//           });
//         } else {
//           modesToShow.forEach(payment => {
//             duplicated.push({
//               sNo: idx + 1,
//               sale_date: item.sale_date,
//               invoice_number: item.invoice_number,
//               patient_id: item.patient_id,
//               "patient_details[0].first_name": item.patient_details?.[0]?.first_name || "N/A",
//               "patient_details[0].patient_type": item.patient_details?.[0]?.patient_type || "N/A",
//               "sales_list[0].purchase_price_per_unit": item.sales_list?.[0]?.purchase_price_per_unit || "0.00",
//               "sales_list[0].mrp": item.sales_list?.[0]?.mrp || "0.00",
//               "sales_list[0].quantity": item.sales_list?.[0]?.quantity || "0",
//               net_total: parseFloat(item.net_total || 0).toFixed(2),
//               paid: parseFloat(payment.paid_amount || 0).toFixed(2),  // ← Only amount
//               pay_type: payment.pay_type,  // ← Only this mode
//               profit: item.sales_list?.reduce((s, sl) => s + (parseFloat(sl.profit) || 0), 0).toFixed(2) || "0.00",
//             });
//           });
//         }
//       });
//       return duplicated;
//     }

//     // Other tabs
//     return filteredData.map((item, idx) => {
//       const row = { sNo: idx + 1 };
//       config.fields.forEach(f => {
//         row[f] = getNestedValue(item, f);
//       });
//       return row;
//     });
//   };

//   const getFilteredData = () => {
//     const data = getCurrentData();
//     if (!searchTerm) return data;
//     return data.filter(item =>
//       Object.values(item).some(v =>
//         v?.toString().toLowerCase().includes(searchTerm.toLowerCase())
//       )
//     );
//   };

//   const getPaginatedData = () => {
//     const data = getFilteredData();
//     const start = (currentPage - 1) * itemsPerPage;
//     return data.slice(start, start + itemsPerPage);
//   };

//   const getTotalPages = () => Math.ceil(getFilteredData().length / itemsPerPage);

//   // ==================== TOTALS ====================
//   const getSalePharmacyTotals = () => {
//     if (activeTab !== "salePharmacy") return { netTotal: 0, paid: 0, profit: 0 };

//     const data = getFilteredData();
//     const invoiceMap = {};
//     let netTotal = 0, paid = 0, profit = 0;

//     data.forEach(item => {
//       const inv = item.invoice_number;
//       if (!invoiceMap[inv]) {
//         invoiceMap[inv] = true;
//         netTotal += parseFloat(item.net_total) || 0;
//         profit += parseFloat(item.profit) || 0;
//       }
//       paid += parseFloat(item.paid) || 0;
//     });

//     return {
//       netTotal: netTotal.toFixed(2),
//       paid: paid.toFixed(2),
//       profit: profit.toFixed(2),
//     };
//   };

//   // ... other totals (unchanged) ...

//   // ==================== EXPORT HELPERS ====================
//   const buildExportRow = (item, fields) => {
//     const row = {};
//     fields.forEach(f => {
//       row[f] = item[f] !== undefined ? item[f] : "";
//     });
//     return row;
//   };

//   // ==================== EXPORTS (PDF, Excel, CSV, Print) ====================
//   const downloadCSV = () => {
//     const data = getFilteredData();
//     const config = tabConfig[activeTab];
//     const fields = ["sNo", ...config.fields];
//     let csv = config.headers.join(",") + "\n";

//     data.forEach(item => {
//       const row = buildExportRow(item, config.fields);
//       const line = fields.map(f => `"${row[f] || ""}"`).join(",");
//       csv += line + "\n";
//     });

//     if (activeTab === "salePharmacy") {
//       const t = getSalePharmacyTotals();
//       const totalLine = [
//         "", "", "", "", "", "", "", "", "",
//         t.netTotal,
//         t.paid,
//         "", t.profit
//       ];
//       csv += totalLine.join(",") + "\n";
//     }

//     const blob = new Blob([csv], { type: "text/csv" });
//     const url = URL.createObjectURL(blob);
//     const a = document.createElement("a");
//     a.href = url; a.download = `${activeTab}_report.csv`; a.click();
//     URL.revokeObjectURL(url);
//   };

//   const download429 = () => {
//     const data = getFilteredData();
//     const config = tabConfig[activeTab];
//     const fields = ["sNo", ...config.fields];
//     let html = `<table border="1"><tr>${config.headers.map(h => `<th>${h}</th>`).join("")}</tr>`;

//     data.forEach(item => {
//       const row = buildExportRow(item, config.fields);
//       html += `<tr>${fields.map(f => `<td>${row[f] || ""}</td>`).join("")}</tr>`;
//     });

//     if (activeTab === "salePharmacy") {
//       const t = getSalePharmacyTotals();
//       html += `<tr>${[
//         "", "", "", "", "", "", "", "", "",
//         t.netTotal,
//         t.paid,
//         "", t.profit
//       ].map(v => `<td>${v}</td>`).join("")}</tr>`;
//     }

//     html += `</table>`;
//     const blob = new Blob([html], { type: "application/vnd.ms-excel" });
//     const url = URL.createObjectURL(blob);
//     const a = document.createElement("a");
//     a.href = url; a.download = `${activeTab}_report.xls`; a.click();
//     URL.revokeObjectURL(url);
//   };

//   const downloadPDF = () => {
//     const data = getFilteredData();
//     const config = tabConfig[activeTab];
//     const fields = ["sNo", ...config.fields];
//     const doc = new jsPDF();

//     doc.setFontSize(18);
//     doc.text(`${config.title} Report`, 14, 20);
//     doc.setFontSize(12);
//     doc.text(`Generated on: ${new Date().toLocaleDateString()}`, 14, 30);

//     const body = data.map(item => {
//       const row = buildExportRow(item, config.fields);
//       return fields.map(f => row[f] || "");
//     });

//     if (activeTab === "salePharmacy") {
//       const t = getSalePharmacyTotals();
//       body.push([
//         "", "", "", "", "", "", "", "", "",
//         t.netTotal,
//         t.paid,
//         "", t.profit
//       ]);
//     }

//     autoTable(doc, {
//       startY: 40,
//       head: [config.headers],
//       body,
//       theme: "striped",
//       headStyles: { fillColor: [46, 146, 144], textColor: [255, 255, 255] },
//     });
//     doc.save(`${activeTab}_report.pdf`);
//   };

//   const handlePrint = () => {
//     const data = getFilteredData();
//     const config = tabConfig[activeTab];
//     const fields = ["sNo", ...config.fields];

//     const printWin = window.open("", "_blank");
//     let html = `
//       <html><head><title>${config.title} Report</title>
//       <style>
//         body{font-family:Arial;margin:20px;}
//         h1{color:#01AEBE;text-align:center;}
//         table{width:100%;border-collapse:collapse;margin-top:20px;}
//         th,td{border:1px solid #ddd;padding:8px;text-align:left;}
//         th{background:#01AEBE;color:white;}
//         tr:nth-child(even){background:#f2f2f2;}
//       </style>
//       </head><body>
//       <h1>${config.title} Report</h1>
//       <p>Generated on: ${new Date().toLocaleDateString()}</p>
//       <table><thead><tr>${config.headers.map(h => `<th>${h}</th>`).join("")}</tr></thead><tbody>
//     `;

//     data.forEach(item => {
//       const row = buildExportRow(item, config.fields);
//       html += `<tr>${fields.map(f => `<td>${row[f] || ""}</td>`).join("")}</tr>`;
//     });

//     if (activeTab === "salePharmacy") {
//       const t = getSalePharmacyTotals();
//       html += `<tr>${[
//         "", "", "", "", "", "", "", "", "",
//         t.netTotal,
//         t.paid,
//         "", t.profit
//       ].map(v => `<td><strong>${v}</strong></td>`).join("")}</tr>`;
//     }

//     html += `</tbody></table></body></html>`;
//     printWin.document.write(html);
//     printWin.document.close();
//     setTimeout(() => { printWin.print(); printWin.close(); }, 250);
//   };

//   // ==================== RENDER TABLE ====================
//   const renderTable = () => {
//     const data = getPaginatedData();
//     const config = tabConfig[activeTab];
//     const fields = ["sNo", ...config.fields];

//     return (
//       <div className="table-responsive">
//         <table className="table table-bordered">
//           <thead>
//             <tr style={{ backgroundColor: "#01AEBE", color: "white" }}>
//               {config.headers.map((h, i) => <th key={i}>{h}</th>)}
//             </tr>
//           </thead>
//           <tbody>
//             {data.map((item, idx) => (
//               <tr key={idx}>
//                 {fields.map((f, i) => (
//                   <td key={i}>
//                     {f === "order_status" ? (
//                       <span className={`badge rounded-pill ${getStatusBadgeClass(item[f])}`}>
//                         <FaCheckCircle /> {item[f]}
//                       </span>
//                     ) : (
//                       item[f]
//                     )}
//                   </td>
//                 ))}
//               </tr>
//             ))}

//             {activeTab === "salePharmacy" && (
//               <tr style={{ backgroundColor: "#f2f2f2", fontWeight: "bold" }}>
//                 <td colSpan={9}>Totals</td>
//                 <td>{getSalePharmacyTotals().netTotal}</td>
//                 <td>{getSalePharmacyTotals().paid}</td>
//                 <td></td>
//                 <td>{getSalePharmacyTotals().profit}</td>
//               </tr>
//             )}
//           </tbody>
//         </table>
//       </div>
//     );
//   };

//   const getStatusBadgeClass = (status) => {
//     const map = {
//       Active: "bg-success", Available: "bg-success", Paid: "bg-success",
//       Completed: "bg-success", Pending: "bg-warning", "Low Stock": "bg-warning",
//       "Out of Stock": "bg-danger",
//     };
//     return map[status] || "bg-success";
//   };

//   // ==================== PAGINATION ====================
//   const renderPagination = () => {
//     const total = getTotalPages();
//     if (total <= 1) return null;
//     const max = 5;
//     let start = Math.max(1, currentPage - Math.floor(max / 2));
//     let end = Math.min(total, start + max - 1);
//     if (end - start + 1 < max) start = Math.max(1, end - max + 1);
//     const pages = [];
//     for (let i = start; i <= end; i++) pages.push(i);

//     return (
//       <div className="d-flex justify-content-between align-items-center mt-3">
//         <div className="text-muted">
//           Showing {(currentPage - 1) * itemsPerPage + 1} to{" "}
//           {Math.min(currentPage * itemsPerPage, getFilteredData().length)} of{" "}
//           {getFilteredData().length} entries
//         </div>
//         <div className="d-flex gap-2">
//           <button className="btn btn-outline-secondary btn-sm" onClick={() => setCurrentPage(Math.max(1, currentPage - 1))} disabled={currentPage === 1}>Previous</button>
//           {pages.map(p => (
//             <button key={p} className={`btn btn-sm ${currentPage === p ? "btn-success" : "btn-outline-secondary"}`} onClick={() => setCurrentPage(p)}>{p}</button>
//           ))}
//           <button className="btn btn-outline-secondary btn-sm" onClick={() => setCurrentPage(Math.min(total, currentPage + 1))} disabled={currentPage === total}>Next</button>
//         </div>
//       </div>
//     );
//   };

//   // ==================== TAB CHANGE ====================
//   const handleTabChange = (key) => {
//     setActiveTab(key);
//     setCurrentPage(1);
//     setSearchTerm("");
//     setFromDate("");
//     setToDate("");
//     setPaymentMode("");
//     setCategory("");
//   };

//   // ==================== RETURN JSX ====================
//   return (
//     <div className="container-fluid p-4" style={{ backgroundColor: "#f8f9fa", minHeight: "100vh" }}>
//       <div className="mb-4">
//         <ul className="nav nav-tabs flex-wrap">
//           {Object.entries(tabConfig).map(([k, c]) => (
//             <li key={k} className="nav-item">
//               <button
//                 className={`nav-link ${activeTab === k ? "active" : ""} px-3 py-2`}
//                 style={{
//                   backgroundColor: activeTab === k ? "#01AEBE" : "transparent",
//                   color: activeTab === k ? "white" : "#01AEBE",
//                   border: "1px solid #01AEBE",
//                   borderRadius: "0",
//                   fontSize: "14px",
//                 }}
//                 onClick={() => handleTabChange(k)}
//               >
//                 {c.title}
//               </button>
//             </li>
//           ))}
//         </ul>
//       </div>

//       <div className="card shadow-sm border-0">
//         <div className="card-header" style={{ backgroundColor: "#01AEBE", color: "white" }}>
//           <div className="row d-flex justify-content-between align-items-center">
//             <div className="col-lg-5 col-md-5 d-flex align-items-center">
//               <h5 className="mb-0 fw-bold">{tabConfig[activeTab]?.title}</h5>
//             </div>

//             <div className="col-lg-7 col-md-7 d-flex justify-content-center align-items-start gap-2 flex-wrap">
//               {["salePharmacy", "purchaseOrder", "purchasePharmacy", "salelist"].includes(activeTab) && (
//                 <>
//                   <div>
//                     <label className="form-label small mb-1 text-white">From Date:</label>
//                     <input type="date" className="form-control form-control-sm" value={fromDate} onChange={(e) => { setFromDate(e.target.value); setCurrentPage(1); }} max={toDate || undefined} />
//                   </div>
//                   <div>
//                     <label className="form-label small mb-1 text-white">To Date:</label>
//                     <input type="date" className="form-control form-control-sm" value={toDate} onChange={(e) => { setToDate(e.target.value); setCurrentPage(1); }} min={fromDate || undefined} />
//                   </div>
//                   {(fromDate || toDate) && (
//                     <div>
//                       <label className="form-label small mb-1 text-white">&nbsp;</label>
//                       <button className="btn btn-outline-light btn-sm w-100" onClick={() => { setFromDate(""); setToDate(""); setCurrentPage(1); }}>
//                         Clear Dates
//                       </button>
//                     </div>
//                   )}
//                 </>
//               )}

//               {activeTab === "salePharmacy" && (
//                 <div>
//                   <label className="form-label small mb-1 text-white">Paytype:</label>
//                   <select className="form-select form-select-sm" value={paymentMode} onChange={(e) => { setPaymentMode(e.target.value); setCurrentPage(1); }}>
//                     <option value="">All</option>
//                     <option value="Cash">Cash</option>
//                     <option value="Card">Card</option>
//                     <option value="Gpay">Gpay</option>
//                     <option value="Phonepe">Phonepe</option>
//                     <option value="Paytm">Paytm</option>
//                     <option value="Amazon Pay">Amazon Pay</option>
//                     <option value="UPI">UPI</option>
//                   </select>
//                 </div>
//               )}

//               {(activeTab === "medicineMaster" || activeTab === "stockManagement" || activeTab === "salePharmacy") && (
//                 <div>
//                   <label className="form-label small mb-1 text-white">Category:</label>
//                   <select className="form-select form-select-sm" value={category} onChange={(e) => { setCategory(e.target.value); setCurrentPage(1); }}>
//                     <option value="">All</option>
//                     <option value="Homeopathy">Homeopathy</option>
//                     <option value="Yoga">Yoga</option>
//                   </select>
//                 </div>
//               )}

//               {activeTab === "salelist" && (
//                 <div>
//                   <label className="form-label small mb-1 text-white">Category:</label>
//                   <select className="form-select form-select-sm" value={category} onChange={(e) => { setCategory(e.target.value); setCurrentPage(1); }}>
//                     <option value="">All</option>
//                     {["Tablet","Capsule","Syrup","Injection","Powder","Sachet","Cream","Ointment","Gel","Drops","Inhaler","Suppository","Suspension","Spray","Lotion","Solution","Patch","Dispersible Tablet","Chewable Tablet","IV Fluid"].map(c => (
//                       <option key={c} value={c}>{c}</option>
//                     ))}
//                   </select>
//                 </div>
//               )}
//             </div>
//           </div>

//           {fromDate && toDate && new Date(fromDate) > new Date(toDate) && (
//             <div className="text-danger small mt-1 text-end">
//               From Date cannot be later than To Date
//             </div>
//           )}
//         </div>

//         <div className="card-body">
//           <div className="row mb-3 align-items-center">
//             <div className="col-md-3">
//               <div className="input-group input-group-sm">
//                 <span className="input-group-text"><i className="fas fa-table"></i></span>
//                 <select className="form-select" value={itemsPerPage} onChange={e => {
//                   const v = e.target.value === "All" ? getFilteredData().length : Number(e.target.value);
//                   setItemsPerPage(v); setCurrentPage(1);
//                 }}>
//                   <option value="All">Show All</option>
//                   {[5, 10, 20, 50, 100, 200, 500, 1000].map(n => <option key={n} value={n}>Show {n}</option>)}
//                 </select>
//               </div>
//             </div>
//             <div className="col-md-2"></div>
//             <div className="col-md-4">
//               <div className="d-flex flex-wrap gap-2">
//                 <button className="btn btn-success btn-sm d-flex align-items-center gap-1" onClick={downloadPDF}><FileText size={16} /> PDF</button>
//                 <button className="btn btn-success btn-sm d-flex align-items-center gap-1" onClick={download429}><FileSpreadsheet size={16} /> Excel</button>
//                 <button className="btn btn-success btn-sm d-flex align-items-center gap-1" onClick={downloadCSV}><Download size={16} /> CSV</button>
//                 <button className="btn btn-success btn-sm d-flex align-items-center gap-1" onClick={handlePrint}><Printer size={16} /> Print</button>
//               </div>
//             </div>
//             <div className="col-md-3">
//               <div className="position-relative">
//                 <input type="text" className="form-control form-control-sm pe-5" placeholder="Search..." value={searchTerm}
//                   onChange={e => { setSearchTerm(e.target.value); setCurrentPage(1); }} />
//                 <Search size={16} className="position-absolute text-muted" style={{ right: "10px", top: "50%", transform: "translateY(-50%)" }} />
//               </div>
//             </div>
//           </div>

//           {isLoading ? (
//             <div className="text-center"><div className="spinner-border text-success"></div></div>
//           ) : (
//             <>
//               {renderTable()}
//               {renderPagination()}
//             </>
//           )}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default ReportPharmacy;


import React, { useEffect, useState, useMemo } from "react";
import {
  Search,
  Download,
  Printer,
  FileSpreadsheet,
  FileText,
} from "lucide-react";
import { FaCheckCircle } from "react-icons/fa";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import axios from "axios";
import Apiurl from "./../../environment/Apiurl";

const ReportPharmacy = () => {
  const [activeTab, setActiveTab] = useState("medicineMaster");
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(5);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [paymentMode, setPaymentMode] = useState("");
  const [category, setCategory] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const [medicineMasterData, setMedicineMasterData] = useState([]);
  const [purchaseOrderData, setPurchaseOrderData] = useState([]);
  const [purchaseListData, setPurchaseListData] = useState([]);
  const [salePharmacyData, setSalesPharmacyData] = useState([]);
  const [salelist, setSaleslist] = useState([]);
  const [stockPharmacyData, setStockPharmacyData] = useState([]);

  // ==================== FETCH FUNCTIONS ====================
  const fetchMedicineMasterData = async () => {
    setIsLoading(true);
    try {
      const { data } = await axios.get(`${Apiurl}/medicine_master`);
      setMedicineMasterData(data || []);
    } catch (e) { console.error(e); setMedicineMasterData([]); } finally { setIsLoading(false); }
  };
  const fetchPurchaseOrderData = async () => {
    setIsLoading(true);
    try {
      const { data } = await axios.get(`${Apiurl}/purchase_order`);
      setPurchaseOrderData(data || []);
    } catch (e) { console.error(e); setPurchaseOrderData([]); } finally { setIsLoading(false); }
  };
  const fetchPurchaseListData = async () => {
    setIsLoading(true);
    try {
      const { data } = await axios.get(`${Apiurl}/purchase_pharmacy_list`);
      setPurchaseListData(data || []);
    } catch (e) { console.error(e); setPurchaseListData([]); } finally { setIsLoading(false); }
  };
  const fetchSalePharmacyData = async () => {
    setIsLoading(true);
    try {
      const { data } = await axios.get(`${Apiurl}/sale`);
      setSalesPharmacyData(data || []);
    } catch (e) { console.error(e); setSalesPharmacyData([]); } finally { setIsLoading(false); }
  };
  const fetchSalelist = async () => {
    setIsLoading(true);
    try {
      const { data } = await axios.get(`${Apiurl}/sale_list_data`);
      setSaleslist(data || []);
    } catch (e) { console.error(e); setSaleslist([]); } finally { setIsLoading(false); }
  };
  const fetchStockPharmacyData = async () => {
    setIsLoading(true);
    try {
      const { data } = await axios.get(`${Apiurl}/stock_pharmacy`);
      setStockPharmacyData(data || []);
    } catch (e) { console.error(e); setStockPharmacyData([]); } finally { setIsLoading(false); }
  };

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  useEffect(() => {
    fetchMedicineMasterData();
    fetchPurchaseOrderData();
    fetchPurchaseListData();
    fetchSalePharmacyData();
    fetchSalelist();
    fetchStockPharmacyData();
  }, []);

  // ==================== TAB CONFIG ====================
  const tabConfig = {
    medicineMaster: {
      title: "Medicine Master",
      headers: ["S.No", "Medicine", "Category", "Medicine Type", "Manufacturer", "HSN Code"],
      fields: ["medicine_name", "category", "medicine_type", "manufacturer", "hsn_code"],
      data: medicineMasterData,
    },
    purchaseOrder: {
      title: "Purchase Order",
      headers: ["S.No", "Date", "Pur Order No", "Supplier Name", "Order Status"],
      fields: ["date", "purchase_order_no", "supplier_details[0].supplier_name", "order_status"],
      data: purchaseOrderData,
    },
    purchasePharmacy: {
      title: "Purchase Product List",
      headers: [
        "S.No", "Purchase Date", "Invoice No", "Supplier ID", "Supplier",
        "Medicine", "Category", "HSN", "Batch No", "Unit Pack",
        "Pur Price", "Qty", "Taxable", "Discount", "Tax(%)",
        "CGST", "SGST", "Tax Value", "Amount (₹)",
      ],
      fields: [
        "purchase_date", "invoice_number", "supplier_id", "supplier_name",
        "medicine_name", "category", "hsn_code", "batch_no", "unit_pack",
        "purchase_price", "quantity", "", "discount_per_tablet", "gst_percentage",
        "", "", "tax", "total",
      ],
      data: purchaseListData,
    },
    salePharmacy: {
      title: "Sale Pharmacy",
      headers: [
        "S.No", "Sale Date", "Invoice No", "Patient ID", "Patient Name",
        "Category", "Pur Price", "MRP", "Qty", "Net Total",
        "Paid ", "PayType", "Profit",
      ],
      fields: [
        "sale_date", "invoice_number", "patient_id",
        "patient_details[0].first_name", "patient_details[0].patient_type",
        "sales_list[0].purchase_price_per_unit", "sales_list[0].mrp",
        "sales_list[0].quantity", "net_total", "paid",
        "pay_type", "profit",
      ],
      data: salePharmacyData,
    },
    salelist: {
      title: "Sales Product List",
      headers: [
        "S.No", "Sale Date", "Invoice No", "Patient ID", "Patient Name",
        "Medicine Name", "HSN Code", "Category", "MRP", "Qty",
        "Tax(%)", "CGST", "SGST", "Tax Value", "Total",
      ],
      fields: [
        "sale_date", "invoice_number", "patient_id", "patient_name",
        "medicine_name", "hsn_code", "category", "mrp", "qty",
        "tax", "cgst", "sgst", "tax_row_value", "total",
      ],
      data: salelist,
    },
    stockManagement: {
      title: "Stock Management",
      headers: [
        "S.No", "Medicine", "Category", "Batch No", "Exp Date",
        "InQty", "OutQty", "Balance", "Pur Price", "MRP", "Profit",
      ],
      fields: [
        "medicine_details.medicine_name", "medicine_details.category",
        "batch_no", "expiry_date", "inward_quantity", "outward_quantity",
        "balance_quantity", "purchase_price", "mrp", "profit",
      ],
      data: stockPharmacyData,
    },
  };

  // ==================== NESTED VALUE ====================
  const getNestedValue = (obj, path) => {
    if (!obj) return "N/A";
    const parts = path.match(/(\w+|\[\d+\])/g) || [path];
    let cur = obj;
    for (const part of parts) {
      if (part.startsWith("[") && part.endsWith("]")) {
        const idx = parseInt(part.slice(1, -1));
        cur = cur ? cur[idx] : undefined;
      } else {
        cur = cur ? cur[part] : undefined;
      }
      if (!cur) break;
    }
    if (["sub_total", "net_total", "discount_value", "paid", "purchase_price", "mrp"].includes(path.split(".").pop())) {
      const v = parseFloat(cur);
      return isNaN(v) ? "0.00" : v.toFixed(2);
    }
    return cur ?? "N/A";
  };

  // ==================== DATE-WISE SORT (NEW) ====================
  const sortByDateDesc = (arr, dateField) => {
    return [...arr].sort((a, b) => {
      const da = new Date(a[dateField] || a.sale_date || a.purchase_date || a.date || 0);
      const db = new Date(b[dateField] || b.sale_date || b.purchase_date || b.date || 0);
      return db - da; // newest first
    });
  };

  // ==================== DATA FILTERING & ROW DUPLICATION ====================
  const getCurrentData = () => {
    const config = tabConfig[activeTab];
    if (!config) return [];

    let filteredData = config.data || [];

    // ---- CATEGORY FILTER ----
    if (category) {
      if (["medicineMaster", "stockManagement", "salelist"].includes(activeTab)) {
        filteredData = filteredData.filter(item => {
          if (activeTab === "medicineMaster") return item.category === category;
          if (activeTab === "stockManagement") return item.medicine_details?.category === category;
          if (activeTab === "salelist") return item.category === category;
          return true;
        });
      }
      if (activeTab === "salePharmacy") {
        filteredData = filteredData.filter(item =>
          item.patient_details?.[0]?.patient_type === category
        );
      }
    }

    // ---- DATE FILTERS ----
    if (["salePharmacy", "salelist", "purchaseOrder", "purchasePharmacy"].includes(activeTab) && (fromDate || toDate)) {
      filteredData = filteredData.filter(item => {
        const itemDate = new Date(item.sale_date || item.purchase_date || item.date);
        if (isNaN(itemDate)) return false;
        let ok = true;
        if (fromDate) {
          const from = new Date(fromDate); from.setHours(0, 0, 0, 0);
          const d = new Date(itemDate); d.setHours(0, 0, 0, 0);
          ok = ok && d >= from;
        }
        if (toDate && ok) {
          const to = new Date(toDate); to.setHours(23, 59, 59, 999);
          const d = new Date(itemDate); d.setHours(23, 59, 59, 999);
          ok = ok && d <= to;
        }
        return ok;
      });
    }

    // ---- PAYMENT MODE FILTER ----
    if (activeTab === "salePharmacy" && paymentMode) {
      filteredData = filteredData.filter(item =>
        Array.isArray(item.sales_pharmacy_payment) &&
        item.sales_pharmacy_payment.some(p => p.pay_type === paymentMode)
      );
    }

    // ---- DATE-WISE SORT (NEWEST FIRST) ----
    const dateKeyMap = {
      salePharmacy: "sale_date",
      salelist: "sale_date",
      purchaseOrder: "date",
      purchasePharmacy: "purchase_date",
    };
    if (dateKeyMap[activeTab]) {
      filteredData = sortByDateDesc(filteredData, dateKeyMap[activeTab]);
    }

    // ---- DUPLICATE ROWS FOR SALE PHARMACY (ONE PER PAYMENT) ----
    if (activeTab === "salePharmacy") {
      const duplicated = [];
      filteredData.forEach((item, idx) => {
        const payments = Array.isArray(item.sales_pharmacy_payment) ? item.sales_pharmacy_payment : [];
        const modesToShow = paymentMode ? payments.filter(p => p.pay_type === paymentMode) : payments;

        if (modesToShow.length === 0) {
          duplicated.push({
            sNo: idx + 1,
            sale_date: item.sale_date,
            invoice_number: item.invoice_number,
            patient_id: item.patient_id,
            "patient_details[0].first_name": item.patient_details?.[0]?.first_name || "N/A",
            "patient_details[0].patient_type": item.patient_details?.[0]?.patient_type || "N/A",
            "sales_list[0].purchase_price_per_unit": item.sales_list?.[0]?.purchase_price_per_unit || "0.00",
            "sales_list[0].mrp": item.sales_list?.[0]?.mrp || "0.00",
            "sales_list[0].quantity": item.sales_list?.[0]?.quantity || "0",
            net_total: parseFloat(item.net_total || 0).toFixed(2),
            paid: "0.00",
            pay_type: "N/A",
            profit: item.sales_list?.reduce((s, sl) => s + (parseFloat(sl.profit) || 0), 0).toFixed(2) || "0.00",
          });
        } else {
          modesToShow.forEach(payment => {
            duplicated.push({
              sNo: idx + 1,
              sale_date: item.sale_date,
              invoice_number: item.invoice_number,
              patient_id: item.patient_id,
              "patient_details[0].first_name": item.patient_details?.[0]?.first_name || "N/A",
              "patient_details[0].patient_type": item.patient_details?.[0]?.patient_type || "N/A",
              "sales_list[0].purchase_price_per_unit": item.sales_list?.[0]?.purchase_price_per_unit || "0.00",
              "sales_list[0].mrp": item.sales_list?.[0]?.mrp || "0.00",
              "sales_list[0].quantity": item.sales_list?.[0]?.quantity || "0",
              net_total: parseFloat(item.net_total || 0).toFixed(2),
              paid: parseFloat(payment.paid_amount || 0).toFixed(2),
              pay_type: payment.pay_type,
              profit: item.sales_list?.reduce((s, sl) => s + (parseFloat(sl.profit) || 0), 0).toFixed(2) || "0.00",
            });
          });
        }
      });
      return duplicated;
    }

    // ---- OTHER TABS ----
    return filteredData.map((item, idx) => {
      const row = { sNo: idx + 1 };
      config.fields.forEach(f => {
        row[f] = getNestedValue(item, f);
      });
      return row;
    });
  };

  const getFilteredData = () => {
    const data = getCurrentData();
    if (!searchTerm) return data;
    return data.filter(item =>
      Object.values(item).some(v =>
        v?.toString().toLowerCase().includes(searchTerm.toLowerCase())
      )
    );
  };

  const getPaginatedData = () => {
    const data = getFilteredData();
    const start = (currentPage - 1) * itemsPerPage;
    return data.slice(start, start + itemsPerPage);
  };

  const getTotalPages = () => Math.ceil(getFilteredData().length / itemsPerPage);

  // ==================== TOTALS ====================
  const getSalePharmacyTotals = () => {
    if (activeTab !== "salePharmacy") return { netTotal: 0, paid: 0, profit: 0 };

    const data = getFilteredData();
    const invoiceMap = {};
    let netTotal = 0, paid = 0, profit = 0;

    data.forEach(item => {
      const inv = item.invoice_number;
      if (!invoiceMap[inv]) {
        invoiceMap[inv] = true;
        netTotal += parseFloat(item.net_total) || 0;
        profit += parseFloat(item.profit) || 0;
      }
      paid += parseFloat(item.paid) || 0;
    });

    return {
      netTotal: netTotal.toFixed(2),
      paid: paid.toFixed(2),
      profit: profit.toFixed(2),
    };
  };

  // ==================== EXPORT HELPERS ====================
  const buildExportRow = (item, fields) => {
    const row = {};
    fields.forEach(f => {
      row[f] = item[f] !== undefined ? item[f] : "";
    });
    return row;
  };

  // ==================== EXPORTS ====================
  const downloadCSV = () => {
    const data = getFilteredData();
    const config = tabConfig[activeTab];
    const fields = ["sNo", ...config.fields];
    let csv = config.headers.join(",") + "\n";

    data.forEach(item => {
      const row = buildExportRow(item, config.fields);
      const line = fields.map(f => `"${row[f] || ""}"`).join(",");
      csv += line + "\n";
    });

    if (activeTab === "salePharmacy") {
      const t = getSalePharmacyTotals();
      const totalLine = [
        "", "", "", "", "", "", "", "", "",
        t.netTotal,
        t.paid,
        "", t.profit
      ];
      csv += totalLine.join(",") + "\n";
    }

    const blob = new Blob([csv], { type: "text/csv" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url; a.download = `${activeTab}_report.csv`; a.click();
    URL.revokeObjectURL(url);
  };

  const downloadExcel = () => {
    const data = getFilteredData();
    const config = tabConfig[activeTab];
    const fields = ["sNo", ...config.fields];
    let html = `<table border="1"><tr>${config.headers.map(h => `<th>${h}</th>`).join("")}</tr>`;

    data.forEach(item => {
      const row = buildExportRow(item, config.fields);
      html += `<tr>${fields.map(f => `<td>${row[f] || ""}</td>`).join("")}</tr>`;
    });

    if (activeTab === "salePharmacy") {
      const t = getSalePharmacyTotals();
      html += `<tr>${[
        "", "", "", "", "", "", "", "", "",
        t.netTotal,
        t.paid,
        "", t.profit
      ].map(v => `<td>${v}</td>`).join("")}</tr>`;
    }

    html += `</table>`;
    const blob = new Blob([html], { type: "application/vnd.ms-excel" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url; a.download = `${activeTab}_report.xls`; a.click();
    URL.revokeObjectURL(url);
  };

  const downloadPDF = () => {
    const data = getFilteredData();
    const config = tabConfig[activeTab];
    const fields = ["sNo", ...config.fields];
    const doc = new jsPDF();

    doc.setFontSize(18);
    doc.text(`${config.title} Report`, 14, 20);
    doc.setFontSize(12);
    doc.text(`Generated on: ${new Date().toLocaleDateString()}`, 14, 30);

    const body = data.map(item => {
      const row = buildExportRow(item, config.fields);
      return fields.map(f => row[f] || "");
    });

    if (activeTab === "salePharmacy") {
      const t = getSalePharmacyTotals();
      body.push([
        "", "", "", "", "", "", "", "", "",
        t.netTotal,
        t.paid,
        "", t.profit
      ]);
    }

    autoTable(doc, {
      startY: 40,
      head: [config.headers],
      body,
      theme: "striped",
      headStyles: { fillColor: [46, 146, 144], textColor: [255, 255, 255] },
    });
    doc.save(`${activeTab}_report.pdf`);
  };

  const handlePrint = () => {
    const data = getFilteredData();
    const config = tabConfig[activeTab];
    const fields = ["sNo", ...config.fields];

    const printWin = window.open("", "_blank");
    let html = `
      <html><head><title>${config.title} Report</title>
      <style>
        body{font-family:Arial;margin:20px;}
        h1{color:#01AEBE;text-align:center;}
        table{width:100%;border-collapse:collapse;margin-top:20px;}
        th,td{border:1px solid #ddd;padding:8px;text-align:left;}
        th{background:#01AEBE;color:white;}
        tr:nth-child(even){background:#f2f2f2;}
      </style>
      </head><body>
      <h1>${config.title} Report</h1>
      <p>Generated on: ${new Date().toLocaleDateString()}</p>
      <table><thead><tr>${config.headers.map(h => `<th>${h}</th>`).join("")}</tr></thead><tbody>
    `;

    data.forEach(item => {
      const row = buildExportRow(item, config.fields);
      html += `<tr>${fields.map(f => `<td>${row[f] || ""}</td>`).join("")}</tr>`;
    });

    if (activeTab === "salePharmacy") {
      const t = getSalePharmacyTotals();
      html += `<tr>${[
        "", "", "", "", "", "", "", "", "",
        t.netTotal,
        t.paid,
        "", t.profit
      ].map(v => `<td><strong>${v}</strong></td>`).join("")}</tr>`;
    }

    html += `</tbody></table></body></html>`;
    printWin.document.write(html);
    printWin.document.close();
    setTimeout(() => { printWin.print(); printWin.close(); }, 250);
  };

  // ==================== RENDER TABLE ====================
  const renderTable = () => {
    const data = getPaginatedData();
    const config = tabConfig[activeTab];
    const fields = ["sNo", ...config.fields];

    return (
      <div className="table-responsive">
        <table className="table table-bordered">
          <thead>
            <tr style={{ backgroundColor: "#01AEBE", color: "white" }}>
              {config.headers.map((h, i) => <th key={i}>{h}</th>)}
            </tr>
          </thead>
          <tbody>
            {data.map((item, idx) => (
              <tr key={idx}>
                {fields.map((f, i) => (
                  <td key={i}>
                    {f === "order_status" ? (
                      <span className={`badge rounded-pill ${getStatusBadgeClass(item[f])}`}>
                        <FaCheckCircle /> {item[f]}
                      </span>
                    ) : (
                      item[f]
                    )}
                  </td>
                ))}
              </tr>
            ))}

            {activeTab === "salePharmacy" && (
              <tr style={{ backgroundColor: "#f2f2f2", fontWeight: "bold" }}>
                <td colSpan={9}>Totals</td>
                <td>{getSalePharmacyTotals().netTotal}</td>
                <td>{getSalePharmacyTotals().paid}</td>
                <td></td>
                <td>{getSalePharmacyTotals().profit}</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    );
  };

  const getStatusBadgeClass = (status) => {
    const map = {
      Active: "bg-success", Available: "bg-success", Paid: "bg-success",
      Completed: "bg-success", Pending: "bg-warning", "Low Stock": "bg-warning",
      "Out of Stock": "bg-danger",
    };
    return map[status] || "bg-success";
  };

  // ==================== PAGINATION ====================
  const renderPagination = () => {
    const total = getTotalPages();
    if (total <= 1) return null;
    const max = 5;
    let start = Math.max(1, currentPage - Math.floor(max / 2));
    let end = Math.min(total, start + max - 1);
    if (end - start + 1 < max) start = Math.max(1, end - max + 1);
    const pages = [];
    for (let i = start; i <= end; i++) pages.push(i);

    return (
      <div className="d-flex justify-content-between align-items-center mt-3">
        <div className="text-muted">
          Showing {(currentPage - 1) * itemsPerPage + 1} to{" "}
          {Math.min(currentPage * itemsPerPage, getFilteredData().length)} of{" "}
          {getFilteredData().length} entries
        </div>
        <div className="d-flex gap-2">
          <button className="btn btn-outline-secondary btn-sm" onClick={() => setCurrentPage(Math.max(1, currentPage - 1))} disabled={currentPage === 1}>Previous</button>
          {pages.map(p => (
            <button key={p} className={`btn btn-sm ${currentPage === p ? "btn-success" : "btn-outline-secondary"}`} onClick={() => setCurrentPage(p)}>{p}</button>
          ))}
          <button className="btn btn-outline-secondary btn-sm" onClick={() => setCurrentPage(Math.min(total, currentPage + 1))} disabled={currentPage === total}>Next</button>
        </div>
      </div>
    );
  };

  // ==================== TAB CHANGE ====================
  const handleTabChange = (key) => {
    setActiveTab(key);
    setCurrentPage(1);
    setSearchTerm("");
    setFromDate("");
    setToDate("");
    setPaymentMode("");
    setCategory("");
  };

  // ==================== RETURN JSX ====================
  return (
    <div className="container-fluid p-4" style={{ backgroundColor: "#f8f9fa", minHeight: "100vh" }}>
      <div className="mb-4">
        <ul className="nav nav-tabs flex-wrap">
          {Object.entries(tabConfig).map(([k, c]) => (
            <li key={k} className="nav-item">
              <button
                className={`nav-link ${activeTab === k ? "active" : ""} px-3 py-2`}
                style={{
                  backgroundColor: activeTab === k ? "#01AEBE" : "transparent",
                  color: activeTab === k ? "white" : "#01AEBE",
                  border: "1px solid #01AEBE",
                  borderRadius: "0",
                  fontSize: "14px",
                }}
                onClick={() => handleTabChange(k)}
              >
                {c.title}
              </button>
            </li>
          ))}
        </ul>
      </div>

      <div className="card shadow-sm border-0">
        <div className="card-header" style={{ backgroundColor: "#01AEBE", color: "white" }}>
          <div className="row d-flex justify-content-between align-items-center">
            <div className="col-lg-5 col-md-5 d-flex align-items-center">
              <h5 className="mb-0 fw-bold">{tabConfig[activeTab]?.title}</h5>
            </div>

            <div className="col-lg-7 col-md-7 d-flex justify-content-center align-items-start gap-2 flex-wrap">
              {["salePharmacy", "purchaseOrder", "purchasePharmacy", "salelist"].includes(activeTab) && (
                <>
                  <div>
                    <label className="form-label small mb-1 text-white">From Date:</label>
                    <input type="date" className="form-control form-control-sm" value={fromDate} onChange={(e) => { setFromDate(e.target.value); setCurrentPage(1); }} max={toDate || undefined} />
                  </div>
                  <div>
                    <label className="form-label small mb-1 text-white">To Date:</label>
                    <input type="date" className="form-control form-control-sm" value={toDate} onChange={(e) => { setToDate(e.target.value); setCurrentPage(1); }} min={fromDate || undefined} />
                  </div>
                  {(fromDate || toDate) && (
                    <div>
                      <label className="form-label small mb-1 text-white">&nbsp;</label>
                      <button className="btn btn-outline-light btn-sm w-100" onClick={() => { setFromDate(""); setToDate(""); setCurrentPage(1); }}>
                        Clear Dates
                      </button>
                    </div>
                  )}
                </>
              )}

              {activeTab === "salePharmacy" && (
                <div>
                  <label className="form-label small mb-1 text-white">Paytype:</label>
                  <select className="form-select form-select-sm" value={paymentMode} onChange={(e) => { setPaymentMode(e.target.value); setCurrentPage(1); }}>
                    <option value="">All</option>
                    <option value="Cash">Cash</option>
                    <option value="Card">Card</option>
                    <option value="Gpay">Gpay</option>
                    <option value="Phonepe">Phonepe</option>
                    <option value="Paytm">Paytm</option>
                    <option value="Amazon Pay">Amazon Pay</option>
                    <option value="UPI">UPI</option>
                  </select>
                </div>
              )}

              {(activeTab === "medicineMaster" || activeTab === "stockManagement" || activeTab === "salePharmacy") && (
                <div>
                  <label className="form-label small mb-1 text-white">Category:</label>
                  <select className="form-select form-select-sm" value={category} onChange={(e) => { setCategory(e.target.value); setCurrentPage(1); }}>
                    <option value="">All</option>
                    <option value="Homeopathy">Homeopathy</option>
                    <option value="Yoga">Yoga</option>
                  </select>
                </div>
              )}

              {activeTab === "salelist" && (
                <div>
                  <label className="form-label small mb-1 text-white">Category:</label>
                  <select className="form-select form-select-sm" value={category} onChange={(e) => { setCategory(e.target.value); setCurrentPage(1); }}>
                    <option value="">All</option>
                    {["Tablet","Capsule","Syrup","Injection","Powder","Sachet","Cream","Ointment","Gel","Drops","Inhaler","Suppository","Suspension","Spray","Lotion","Solution","Patch","Dispersible Tablet","Chewable Tablet","IV Fluid"].map(c => (
                      <option key={c} value={c}>{c}</option>
                    ))}
                  </select>
                </div>
              )}
            </div>
          </div>

          {fromDate && toDate && new Date(fromDate) > new Date(toDate) && (
            <div className="text-danger small mt-1 text-end">
              From Date cannot be later than To Date
            </div>
          )}
        </div>

        <div className="card-body">
          <div className="row mb-3 align-items-center crm-table-toolbar">
            <div className="col-md-3">
              <div className="input-group input-group-sm">
                <span className="input-group-text"><i className="fas fa-table"></i></span>
                <select className="form-select" value={itemsPerPage} onChange={e => {
                  const v = e.target.value === "All" ? getFilteredData().length : Number(e.target.value);
                  setItemsPerPage(v); setCurrentPage(1);
                }}>
                  <option value="All">Show All</option>
                  {[5, 10, 20, 50, 100, 200, 500, 1000].map(n => <option key={n} value={n}>Show {n}</option>)}
                </select>
              </div>
            </div>
            <div className="col-md-2"></div>
            <div className="col-md-4">
              <div className="d-flex flex-wrap gap-2">
                <button className="btn btn-success btn-sm d-flex align-items-center gap-1" onClick={downloadPDF}><FileText size={16} /> PDF</button>
                <button className="btn btn-success btn-sm d-flex align-items-center gap-1" onClick={downloadExcel}><FileSpreadsheet size={16} /> Excel</button>
                <button className="btn btn-success btn-sm d-flex align-items-center gap-1" onClick={downloadCSV}><Download size={16} /> CSV</button>
                <button className="btn btn-success btn-sm d-flex align-items-center gap-1" onClick={handlePrint}><Printer size={16} /> Print</button>
              </div>
            </div>
            <div className="col-md-3">
              <div className="position-relative">
                <input type="text" className="form-control form-control-sm pe-5" placeholder="Search..." value={searchTerm}
                  onChange={e => { setSearchTerm(e.target.value); setCurrentPage(1); }} />
                <Search size={16} className="position-absolute text-muted" style={{ right: "10px", top: "50%", transform: "translateY(-50%)" }} />
              </div>
            </div>
          </div>

          {isLoading ? (
            <div className="text-center"><div className="spinner-border text-success"></div></div>
          ) : (
            <>
              {renderTable()}
              {renderPagination()}
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default ReportPharmacy;